import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ActivatedRoute, Router } from '@angular/router';
import * as printJS from 'print-js';
import { Store } from 'src/app/models/store';
import { Client } from "src/app/models/client";
import { Company } from "src/app/models/company";
import { StoreService } from 'src/app/services/store.service';
import { ClientService } from 'src/app/services/client.service';
import { CompanyService } from 'src/app/services/company.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { InvoiceHeader } from '../../../../models/invoiceHeader';
import { InvoiceDetail } from '../../../../models/invoiceDetail';
import { InvoiceService } from 'src/app/services/invoice.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { LetrasPipe } from 'src/app/pipe/letras/letras.pipe';
import { UtilsService } from 'src/app/services/utils.service';
import swal from "sweetalert2";
import { RestaurantService } from 'src/app/services/restaurant.service'
import { ProductService } from 'src/app/services/product.service';
import { PrintService } from 'src/app/services/print.service';

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Console } from 'console';
import { ConnectableObservable } from 'rxjs';
import { ConsoleLogger } from '@aws-amplify/core';

@Component({
  selector: 'app-restaurant',
  templateUrl: './restaurant.component.html',
  styleUrls: ['./restaurant.component.scss'],
  providers: [ClientService, StoreService, CompanyService, InventoryService, InvoiceService, WarehouseService, UtilsService, RestaurantService, ProductService, PrintService]
})
export class RestaurantComponent implements OnInit {
  // Variables auxiliares
  pipeLetra = new LetrasPipe();
  pipeFecha = new DatePipe('en-US');
  store = {} as Store;
  client = {} as Client;
  company = {} as Company;
  invoiceHeader = {} as InvoiceHeader;
  invoiceDetail = {} as InvoiceDetail;
  public nowDay: string;
  public userCode: number;
  public userName: string;
  public storeCode: number;
  public storeName: string;
  public companyCode: number;
  public files = {};
  public temp = [];
  loading;

  public isBeginning: boolean;
  public isBilling: boolean;
  public isPrintT: boolean;
  public isPrintTR: boolean;
  public isPrintOrder: boolean = false;
  public isPrintL: boolean;
  public isEdit: boolean;
  public isDisabled: boolean;
  public recurrentClient: boolean;
  public insertNewClient: boolean = false; //crear cliente si no existe
  public activeRow: any;
  public isNailCenter: boolean;
  public ordersLocked: boolean;
  public PaymentStatus: boolean;

  // DATA SELECT
  public id: number;
  public itemName: string;
  public selectedItems = [];
  public inventoryList: any[] = new Array();
  public dropdownSettings: IDropdownSettings = {};
  closeDropdownSelection = false;
  public _categoryProductList: any[] = new Array();
  public productList: any[] = new Array();
  public viewproduct: boolean = false;
  public viewAdds: boolean = false;
  public viewProp: boolean = false;
  public cardQuantities: { [sku: string]: number } = {};
  public _addsProductList: any[] = new Array();
  public phoneWhastapp: string = "";
  //public dropdownSettingsProduct = {};

  // DATA SELECT SERIAL
  public selectedItemsSerial = [];
  public serialList: any[] = new Array();
  public dropdownSettingsSerial: IDropdownSettings = {};
  closeDropdownSelectionSerial = false;
  public serialSelected = new Array;
  public serialSelectedTemp = new Array;

  // Variables de Linea de Compra
  public itemCode: string;
  public stock: number;
  public Minstock: number;
  public moneda: string;
  public invoiceLine: any = new Array;
  public addAmount: boolean;
  public idp: number;
  public subIdp: number;
  public subsidio: number;
  public subsidioTemp: number;
  public isOil: number;
  public petroleo: string;
  public taxOilCode: number;
  public taxOilAmount: number;
  public dte: any;
  public fel: any;
  public felDetail: any;
  public priceType: number;
  public companyLogoUrl: string;
  public taxToPay: number = 0
  public regimenMessage: string = '';
  public inventoryPriceDefault: number = 1;

  //FACTURAR DESDE CLIENT
  public code: number = 0;
  public url: any;
  activatedRoute: ActivatedRoute | null | undefined;

  //FACTURA DESDE TRANSFERENCIA
  public isParamsUrl: boolean = false;
  public transferCode: any;
  public transferDetail: any[];
  public total: number;

  //Prueba de impresion
  public infile: any;
  public megaprint: any;

  public disabled = false;
  public disabledEXT = false;
  public facturando: boolean;

  public tipoCliente = 0;
  public tipoPago = 0;
  public OrdenCompra = "0";
  public entries: number = 10;

  // DATA SELECT PAYMENT
  public idPayment: number;
  public itemNamePayment: string;
  public selectedItemsPayment = [];
  public PaymentList: any[] = [];
  public isChecked: boolean = false;
  public showOrderDetail: boolean = false;
  public showPaymentMethods: boolean = false;
  public showInvoiceInfo: boolean = false;
  public dropdownSettingsPayment: IDropdownSettings = {};
  closeDropdownSelectionPayment = false;
  
  public PaymentLine: any = new Array();
  public PaymentType = 0;
  public NamePaymentType = 0;
  public MontoPayment: number = 0.00;
  public MontoTotalPayment: number = 0.00;
  public amountToPay: number = 0.00;
  public Autorizacion: string = "0";
  public disabledPay = true;
  public isDisabledInvoice = false;
  public isMethodPay = false;
  public isMoney: boolean = false;
  public MoneyPay: number = 0.00;
  public Money: number = 0.00;
  public Propina: number = 0.00;
  public changeMoney: number = 0.00;

  // DATA SELECT SALES PERSON
  public selectedItemsSalesP = [];
  public SalesPList: any[] = new Array();
  public dropdownSettingsSalesP: IDropdownSettings = {};
  //public dropdownSettingsSalesP = {};
  closeDropdownSelectionSalesP = false;
  public SalesPerson = 0;

  public tablesList: any[] = new Array();
  public maxCheckQuantity: number = 1;
  public checkQuantitySelected: number = 1;
  public divideInChecksEnabled: boolean = false;
  public checkNumberPaymentMethod: number = 1;
  public productsByCheck: any[] = new Array();
  public checkClientNIT: number = 1;
  // public addPaymentMethodEnabled: boolean = false;
  public mesaOrden: number = 0;
  public orderActive: boolean = false;
  public orderID: number = 0;
  public payOrderButtonEnabled: boolean = true;
  public updateOrderFromPayment: boolean  = false;
  public closeOrder: boolean = false;
  public all: boolean = false;
  public closeOrderComplete: boolean = false;

  public OpenCash: boolean;

  constructor(
    private _utilsService: UtilsService,
    private _storeService: StoreService,
    private _clientService: ClientService,
    private _companyService: CompanyService,
    private _invoiceService: InvoiceService,
    private _inventoryService: InventoryService,
    private _warehouseService: WarehouseService,
    private cdref: ChangeDetectorRef,
    private router: Router,
    private _pipeNumero: DecimalPipe,
    private _restaurantService: RestaurantService,
    private _productService: ProductService,
    private _printService: PrintService,
  ){}

  async ngOnInit() {
    this.isNailCenter = false;
    this.addAmount = true;
    this.isEdit = false;
    this.isDisabled = false;
    this.disabled = false;
    this.jumpSerial = false;
    this.insertNewClient = false;
    this.idp = 0;
    this.subIdp = 0;
    this.subsidio = 0;
    this.subsidioTemp = 0;
    this.taxToPay = 0;
    this.moneda = "Q";
    this.priceType = 1;
    this.petroleo = null;
    this.taxOilAmount = 0;
    this.taxOilCode = null;
    this.invoiceHeader.invoiceIDP = 0;
    this.invoiceHeader.invoiceCoin = 0;
    this.invoiceHeader.invoiceTax = 0;
    this.invoiceHeader.invoiceTotal = 0;
    this.invoiceHeader.invoiceCurrency = 'GTQ';
    this.invoiceHeader.origenCompra = 1;
    this.invoiceDetail.invoiceDetailType = 'B';
    this.invoiceDetail.invoiceDetailQuantity = 1;
    this.invoiceHeader.invoiceInternSerial = 'A';
    this.invoiceHeader.paymentType = 0;
    this.invoiceHeader.invoiceExchangeRate = 0;
    this.tipoPago = 0;
    this.ordersLocked = true;
    this.PaymentStatus = false;
    this.viewProp = false;

    this.nowDay = this._utilsService.dateTime('yyy-MM-dd');
    this.invoiceHeader.invoiceDate = this.nowDay;

    // GET ID USER & ID COMPANY
    const _data = JSON.parse(localStorage.getItem('data'));
    this.storeName = _data.storeName ? _data.storeName.toString() : null;
    this.userCode = _data.userCode ? parseInt(_data.userCode.toString()) : 0;
    this.storeCode = _data.storeCode ? parseInt(_data.storeCode.toString()) : 0;
    this.companyCode = _data.companyCode ? parseInt(_data.companyCode.toString()) : 0;
    const _user = JSON.parse(localStorage.getItem('user'));
    this.userName = _user.userName ? _user.userName.toString() : '';
    this.invoiceHeader.invoiceInternSerial = _user.userSerial ? _user.userSerial.toString() : 'A';

    this.loading = true;
    this.viewBeginning();    
    await this.getStore(this.storeCode);
    await this.getCompany(this.companyCode);    
    await this.getInventoryList(this.storeCode);   
    await this.getSelectSetting(this.selectedItems);
    this.getSelectSettingSerial(this.selectedItemsSerial);
    //await this.getTablesList(this.storeCode);
    await this.getAllCategory(this.companyCode);

    await this.getSalesPList(this.storeCode);
    await this.getPaymetList(this.storeCode);    
    this.getSelectSettingPaymet(this.selectedItemsPayment);
    this.getSelectSettingSalesP(this.selectedItemsSalesP);    

    // console.log('Select -> ', this.selectedItems);
    // console.log('Select Tipo pagos -> ', this.selectedItemsPayment);
    // console.log('Tipo pagos -> ', this.PaymentList);

    console.log('Store', this.store);
    console.log('Company', this.company);

    this.OpenCash = this.company.companyOpenCash == 1 ? this.OpenCash = true : this.OpenCash = false;
    console.log('OpenCash -> ', this.OpenCash);

    await this.Pagado();

    this.SKUx = "";
    this.client.clientType = 0;
    this.tipoCliente = 0;
    this.disabledEXT = true;
    this.disabled = false;

    if(this.companyCode == 22){
      this.isNailCenter = true;
      this.getAll(this.storeCode);
    }

    this.loading = false;

    this.url = this.router.parseUrl(this.router.url);
    if (this.url.queryParams['nit'] != undefined) {

      if (localStorage.getItem('clientData') !== null) {
        // console.log('si hay data de cliente');

        let _dataCli = JSON.parse(localStorage.getItem('clientData'));

        // console.log('localstorage -> ', _dataCli.clientName);

        this.client.clientName = _dataCli.clientName;
        this.client.clientStatus = 1;
        this.client.clientDeleted = 0;
        this.client.clientPhone = _dataCli.clientPhone;
        this.client.clientEmail = _dataCli.clientEmail;
        this.client.clientAddress = _dataCli.clientAddress;
        this.client.clientCode =  _dataCli.clientCode;
        this.client.clientTaxDocument = _dataCli.clientTaxDocument;        
        this.tipoCliente = _dataCli.clientType;
        this.client.clientType = _dataCli.clientType;

        this.viewBilling();
        this.loading = false;
        this.isDisabled =false;

        // console.log('Cliente -> ', this.client);
        // console.log('Tipo Cliente -> ', this.tipoCliente);
  
        this.insertNewClient = false;
        this.recurrentClient = true;
      }

      // this.isParamsUrl = true;
      // this.code = this.url.queryParams['nit'];
      // await this.buscarNITLocal(event, this.code);

      if (this.url.queryParams['transfer']) {
        let transfer = this.url.queryParams['transfer'];
        await this.cargarTrasnferencia(transfer);
      }
    } 
  }

  async onItemSelectPaymet(item: any) {
    // console.log("---item---");
    // console.log(item);
    const _selectedItemPayment = await this.PaymentList.find(x => x.id == item.id);
    console.log(_selectedItemPayment);

    this.tipoPago = item.payMethodBusinessCode;
    this.PaymentType = this.tipoPago;
    this.NamePaymentType = item.payMethodName;
  }

  getPaymetList(code) {
    return this._storeService.getPaymets(code).then(
      response => {
        if (response.result) {
          this.PaymentList = response.records;
          // console.log("paymentList ->" + JSON.stringify(response.records));
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  getSelectSettingPaymet(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsPayment = [selected] : '';

    this.dropdownSettingsPayment = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'payMethodBusinessCode',
      textField: 'payMethodName'
    };
  }

  async addPaymentDetail(){
    this.MontoTotalPayment = parseFloat(((this.MontoTotalPayment + (this.MontoPayment))).toFixed(6));
    console.log('payment',(this.MontoTotalPayment).toFixed(6));

    this.MontoTotalPayment = parseFloat((this.MontoTotalPayment).toFixed(6));
    console.log('payment to',parseFloat((this.MontoTotalPayment).toFixed(6)).toFixed(6));

    let copyOfPaymentLine = {...this.PaymentLine[this.checkNumberPaymentMethod-1]}
    copyOfPaymentLine.typePayment = this.PaymentType;
    copyOfPaymentLine.NamePaymentType = this.NamePaymentType;
    copyOfPaymentLine.MontoPayment = this.MontoPayment;
    copyOfPaymentLine.Autorizacion = this.Autorizacion;
    copyOfPaymentLine.checkNumber = this.checkNumberPaymentMethod;

    // this.PaymentLine[this.checkNumberPaymentMethod-1] = {...copyOfPaymentLine};
    this.PaymentLine.push({...copyOfPaymentLine})

    if(this.PaymentType == 0)
    {
      this.MoneyPay = this.MoneyPay + this.MontoPayment;
      this.isMoney = true;
    }

    let typePaymentCount = 0;

    await this.PaymentLine.forEach(async (e) => {
      console.log('tipo',e.typePayment);
      if(e.typePayment == 0) typePaymentCount++;
    });

    console.log('typePaymentCount',typePaymentCount);
    if(typePaymentCount >= 1)
    {
      this.isMoney = true;
    }else{
      this.isMoney = false;
    }

    this.MontoPayment = 0;
    this.Autorizacion = "0";
    this.selectedItemsPayment = [];
    this.checkNumberPaymentMethod = 1;

    this.Pagado();
  }

  async deletePaymentDetail(index) {
    let typePaymentCount = 0;

    this.MontoTotalPayment = parseFloat(((this.MontoTotalPayment - (this.PaymentLine[index].MontoPayment))).toFixed(6));        
    // this.PaymentLine[index] = {};   
    
    console.log('forma pago eliminado',this.PaymentLine[index].typePayment);    

    this.MoneyPay = this.MoneyPay - this.PaymentLine[index].MontoPayment;
    this.PaymentLine.splice(index,1);

    await this.PaymentLine.forEach(async (e) => {
      console.log('tipo',e.typePayment);
      if(e.typePayment == 0) typePaymentCount++;
    });

    console.log('typePaymentCount',typePaymentCount);
    if(typePaymentCount >= 1)
    {
      this.isMoney = true;
    }else{
      this.isMoney = false;
    }
    
    this.Pagado();
  }

  calculateChangeMoney($event: any){
    // console.log(this.Money);
    // console.log(this.MontoTotalPayment);
    let Change = parseFloat(((this.Money - (this.MontoTotalPayment))).toFixed(6));
    this.changeMoney = Change
  }

  async Pagado(){
    if(this.company.companyPaymentType == 1){
      this.MontoPayment = 0.00;
      this.isMethodPay = true;
      
      let invoiceTotalx = parseFloat((this.invoiceHeader.invoiceTotal).toFixed(2)).toFixed(2);
      let MontoTotalPaymentx = parseFloat((this.MontoTotalPayment).toFixed(2)).toFixed(2);
      let amountToPayx = parseFloat((this.amountToPay).toFixed(2)).toFixed(2);
      console.log('MontoTotalPayment',MontoTotalPaymentx, 'invoiceTotal', invoiceTotalx, 'amountToPay', amountToPayx)

      if((MontoTotalPaymentx == amountToPayx) && this.MontoTotalPayment > 0){
        console.log('1');
        this.isDisabledInvoice = false;
      }
      else if(MontoTotalPaymentx > amountToPayx){
        console.log('2');
        this.isDisabledInvoice = true;
        this._utilsService.showNotification(2,"Total pagado es mayor al Total de la factura")
      }
      else{
        console.log('3');
        this.isDisabledInvoice = true;
      }
    }
    else{
      this.isMethodPay = false;
      this.isDisabledInvoice = false;
    }
  }

  /////////////////////FUNCTIONS SALES PERSONS/////////////////////////////////
  getSalesPList(code) {    
    return this._storeService.getSalesPerson(code,1).then(
      response => {
        if (response.result) {
          this.SalesPList = response.records;
          // console.log('vendedores', this.SalesPList);
          // console.log("this.inventoryList ->" + code);
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  async onItemSelectSalesP(item: any) {
    // console.log("---item---");
    // console.log(item);
    const _selectedItemSalesP = await this.SalesPList.find(x => x.id == item.id);
    // console.log(_selectedItemSalesP);

    this.SalesPerson = item.salesPersonCodeUser;
    // console.log('SalesPerson -> ', this.SalesPerson);
  }

  getSelectSettingSalesP(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsSalesP = [selected] : '';

    this.dropdownSettingsSalesP = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'salesPersonCodeUser',
      textField: 'salesPersonName'
    };
  }

  ///////////////////////FUNCTION FOR TABLE///////////////////////
  entriesChange($event) {
    this.entries = $event.target.value;
  }

  filterTable($event) {
    let val = $event.target.value.toLowerCase();
    this.temp = this.inventoryList.filter(function (d) {
      for (var key in d) {
        if (d[key] !== null) {
          if (d[key].toString().toLowerCase().indexOf(val) !== -1) {
            return true;
          }
        }
      }
      return false;
    });
  }

  /////////////////////AGREGAR LINEA DESCRIPCION AL DETALLE FACTURA///////////////////////////
  saveLineInvoiceDesc() {
    if (this.invoiceDetail.invoiceDetailDescription != "" && this.invoiceDetail.invoiceDetailQuantity > 0 && this.invoiceDetail.invoiceDetailUnitPrice > 0) {
      //Calcular subtotal de linea
      this.invoiceDetail.invoiceDetailSubtotal = this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice;

      if (this.invoiceDetail.invoiceDetailDiscount != undefined && this.invoiceDetail.invoiceDetailDiscount != null && this.invoiceDetail.invoiceDetailDiscount > 0) {
        this.invoiceDetail.invoiceDetailSubtotal = this.invoiceDetail.invoiceDetailSubtotal - this.invoiceDetail.invoiceDetailDiscount;
        this.invoiceDetail.invoiceDetailTax = this.invoiceDetail.invoiceDetailSubtotal - (this.invoiceDetail.invoiceDetailSubtotal / this.taxToPay);
      } else {
        this.invoiceDetail.invoiceDetailDiscount = 0;
      }

      //Insertar
      if (this.addAmount == true) {
        console.log('Inserta descripcion');
        this.invoiceLine.push({
          subsidio: this.subsidioTemp,
          isOil: this.isOil,
          taxOilUP: this.idp,
          taxOilAmount: this.subIdp,
          taxOilName: this.petroleo,
          taxOilCode: this.taxOilCode,
          taxOilQuantity: this.invoiceDetail.invoiceDetailQuantity,          
          itemCode: 0,//this.itemCode,
          measure: "UNI",
          taxCode: 1,
          taxName: "IVA",
          isService: "B",
          quantity: parseFloat(this.invoiceDetail.invoiceDetailQuantity.toFixed(4)),
          description: this.invoiceDetail.invoiceDetailDescription,
          unitPrice: parseFloat(this.invoiceDetail.invoiceDetailUnitPrice.toFixed(4)),
          price: parseFloat((this.invoiceDetail.invoiceDetailSubtotal + this.invoiceDetail.invoiceDetailDiscount).toFixed(4)),
          discount: parseFloat(this.invoiceDetail.invoiceDetailDiscount.toFixed(4)),
          taxAmount: parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(4)),
          taxableAmount: parseFloat((this.invoiceDetail.invoiceDetailSubtotal - this.invoiceDetail.invoiceDetailTax).toFixed(4)),
          total: parseFloat(this.invoiceDetail.invoiceDetailSubtotal.toFixed(4))
        });
      }

      // Sumar Total
      this.invoiceHeader.invoiceTotal += this.invoiceDetail.invoiceDetailSubtotal;
      this.invoiceHeader.invoiceTax += this.invoiceDetail.invoiceDetailTax;
      this.cleanLineInvoice();
    }

    this.ValidarCF();
    this.Pagado();

    this.isDisabled = false;
  }

  // CALCULAR IMPUESTO DE LINEA
  calculateTax() {
    let subTotalLine;

    subTotalLine = (this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice);

    if (this.invoiceDetail.invoiceDetailDiscount > 0) {
      if (this.invoiceDetail.invoiceDetailDiscount <= subTotalLine) {
        subTotalLine = subTotalLine - this.invoiceDetail.invoiceDetailDiscount;
      } else {
        this._utilsService.showNotification(2, "Cantidad No permitida");
        this.invoiceDetail.invoiceDetailDiscount = 0;
      }
    }

    let tax;
    tax = (subTotalLine - (subTotalLine / this.taxToPay)).toFixed(6);
    this.invoiceDetail.invoiceDetailTax = parseFloat(tax);
  }  

  increaseQty(sku: string) {
    this.cardQuantities[sku] = (this.cardQuantities[sku] || 1) + 1;
  }

  decreaseQty(sku: string) {
    this.cardQuantities[sku] = Math.max(1, (this.cardQuantities[sku] || 1) - 1);
  }

  setQty(sku: string, event: Event) {
    const val = parseInt((event.target as HTMLInputElement).value, 10);
    this.cardQuantities[sku] = val >= 1 ? val : 1;
  }

  async addFood(SKU, qty: number = 1){
    var sku = SKU;
    this.invoiceDetail.invoiceDetailQuantity = qty >= 1 ? qty : 1;

    const SKUs = this.inventoryList.find(({ inventoryBusinessCode }) => inventoryBusinessCode === sku);
    // console.log('SKU Buscado', SKUs);

    if(SKUs == undefined){
      this._utilsService.showNotification(2, 'Producto no disponible, validar disponibilidad en inventario');
    }
    else
    {
      if(sku.length > 0){
        //const _selectedItem = await this.inventoryList.find(x => x.id == sku);
        const _selectedItem = SKUs
        console.log('----_selectedItem---', _selectedItem);
  
        //SI ES PETROLIO
        this.idp = 0;
        this.subIdp = 0;
        this.subsidioTemp = 0;
        this.isOil = null;
        this.petroleo = null;
        this.itemCode = _selectedItem.inventoryCode;
        this.invoiceDetail.invoiceDetailDescription = _selectedItem.itemName;
        this.invoiceDetail.invoiceDetailType = 'B';
        this.stock = _selectedItem.inventoryQuantity;
        this.Minstock = _selectedItem.inventoryMin;
        this.inventoryPriceDefault = _selectedItem.inventoryPriceDefault;
  
        if (_selectedItem.inventorySerialFlag == 1) {
          this.loading = true;
          this.serialSelectedTemp = [];
          this.serialList = [];
          const response = await this._inventoryService.getItemSerial(this.itemCode);
          this.serialList = response.records[1];
  
          this.serial = true;
          this.loading = false;
        } else {
          this.serial = false
        }
  
        await this.saveLineInvoice();
        this.cardQuantities[sku] = 1;
        this.payOrderButtonEnabled = false;
        this.SKUx = "";

        if(_selectedItem.inventoryAdds == 1){
          this.viewAdditionals(this.itemCode);
          console.log('_categoryProductList',this._categoryProductList);
        }
      }
    }
  }

  showProducts(){
    this.viewproduct = true;
    this.viewAdds = false;
  }

  async unlockOrders() {
    this.viewCategory();
    this.ordersLocked = false;    
  }

  async asignarMesa(mesa) {
    this.loading = true;
    this.mesaOrden = mesa;
    this.ordersLocked = false;

    this.viewCategory();

    return this._restaurantService.getOrder(this.storeCode,this.mesaOrden, 1).then(
      async response => {
        if (response.result) {
          //SI LA MESA TIENE ORDEN ABIERTA
          if(response.records.length >= 1){
            this._utilsService.showNotification(1, "Orden existente abierta");
            this.orderActive = true;
            this.orderID = response.records[0].restaurantOrdersCode;
            this.invoiceLine = JSON.parse(response.records[0].restaurantOrdersDetail);

            this.invoiceLine.forEach(product => {
              product.inCheck = 1;
            });

            this.maxCheckQuantity = this.invoiceLine.length;

            for await (const e of this.invoiceLine) {
              this.subsidio += e.subsidio;            
              this.invoiceHeader.invoiceIDP += parseFloat((e.taxOilAmount).toFixed(6));
              this.invoiceHeader.invoiceTotal += parseFloat((e.total).toFixed(6));
              this.invoiceHeader.invoiceTax += parseFloat((e.taxAmount).toFixed(6));              
            }
            this.Pagado();
          }
          //NUEVA ORDEN
          else{
            this._utilsService.showNotification(1, "Nueva Orden");
            this.orderActive = false;
          }
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }
  
  async paymentUnlock() {

    await this.saveOrder();

    // console.log('Inicia Pagar');
    this.ordersLocked = false;
    this.PaymentStatus = true;
    this.showOrderDetail = true;
    this.updateOrderFromPayment = false;
    this.loading = true;    

    return this._restaurantService.getOrder(this.storeCode,this.mesaOrden, 1).then(
      async response => {
        if (response.result) {
          //SI LA MESA TIENE ORDEN ABIERTA
          if(response.records.length >= 1){
            this._utilsService.showNotification(1, "Orden cargada");
            this.orderActive = true;
            this.orderID = response.records[0].restaurantOrdersCode;
            this.invoiceLine = JSON.parse(response.records[0].restaurantOrdersDetail);
            this.subsidio = 0;            
            this.invoiceHeader.invoiceIDP = 0;
            this.invoiceHeader.invoiceTotal = 0;
            this.invoiceHeader.invoiceTax = 0;  

            this.invoiceLine.forEach(product => {
              product.inCheck = 1;
              this.subsidio += product.subsidio;            
              this.invoiceHeader.invoiceIDP += parseFloat((product.taxOilAmount).toFixed(6));
              this.invoiceHeader.invoiceTotal += parseFloat((product.total).toFixed(6));
              this.invoiceHeader.invoiceTax += parseFloat((product.taxAmount).toFixed(6));  
            });

            this.maxCheckQuantity = this.invoiceLine.length;
            this.Pagado();
            this.PaymentLine = []
          }
          //NO HAY ORDEN EXISTENTE
          else{
            this._utilsService.showNotification(1, "Ningún producto ordenado");
            this.orderActive = false;
          }
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
      console.log('Fin Pagar');
    });    
  }

  async amountAdd() {
    this.Money = this.Money + 100;
    this.calculateChangeMoney(this.Money);
  }

  async getCategory(category){
    const _selectedCategory = await this.inventoryList.filter(x => x.inventoryProduct == category);
    console.log('Categorias ->', _selectedCategory);
    this._categoryProductList = _selectedCategory;
    console.log('Productos ->', this._categoryProductList);
    this.viewproduct = true;
  }

  async getAdds(codProduct){
    const _selectedAdds = await this.inventoryList.filter(x => x.inventoryAddsCodeInventory == codProduct);
    // console.log('Extras ->', _selectedAdds);
    this._addsProductList = _selectedAdds;
    // console.log('Productos Extras ->', this._addsProductList);
  }

  async viewCategory() {
    this.viewproduct = false;
    this.viewAdds = false;
    this.viewProp = false;
  }

  async viewPropinas() {
    this.viewproduct = false;
    this.viewAdds = false;
    this.viewProp = true;
  }

  async viewAdditionals(codProduct){
    this.viewproduct = false;
    this.viewAdds = true;
    this.viewProp = false;
    await this.getAdds(codProduct);
  }

  getAllCategory(Company) {
    this.loading = true;

    return this._productService.getAll(this.companyCode).then(
      response => {
        if (response.result) {
          this.productList = response.records;
          //console.log('productList',this.productList);
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  async cleanOrder(){

    //await this.saveOrder();

    this.invoiceLine = [];
    this._categoryProductList = [];
    this.invoiceHeader.invoiceTotal = 0;

    this.client = {} as Client;
    this.invoiceHeader = {} as InvoiceHeader;
    this.invoiceDetail = {} as InvoiceDetail;
    this.moneda = "Q";
    this.petroleo = null;
    this.taxOilAmount = 0;
    this.taxOilCode = null;
    this.invoiceHeader.invoiceIDP = 0;
    this.invoiceHeader.invoiceTax = 0;
    this.invoiceHeader.invoiceTotal = 0;
    this.invoiceHeader.invoiceCoin = 0;
    this.invoiceHeader.invoiceCurrency = 'GTQ';
    this.invoiceDetail.invoiceDetailType = 'B';    
    this.invoiceDetail.invoiceDetailQuantity = 1;
    this.invoiceHeader.invoiceInternSerial = 'A';
    this.invoiceHeader.paymentType = 0;
    this.tipoPago = 0;
    this.invoiceHeader.invoiceDate = this.nowDay;
    this.client.clientType = 0;
    this.OrdenCompra = "0";

    this.jumpSerial = false;
    this.idp = 0;
    this.subIdp = 0;
    this.subsidio = 0;
    this.subsidioTemp = 0;
    //this.taxToPay = 0;
    this.priceType = 1;
    this.PaymentLine = [];
    this.MontoTotalPayment = 0;
    this.viewproduct = false;
    this.maxCheckQuantity = 1;
    this.divideInChecksEnabled = false;

    await this.deleteOrder();
  }

  async deleteOrder(){
    this.loading = true;

    let json = {
      "store": {
        "storeCode": this.storeCode
      },
      "user": {
        "userCode": this.userCode
      },
      "table": {
        "tableCode": this.mesaOrden
      },
      "detail": this.invoiceLine,
      "orderCode": this.orderID,
      "status": 0 //Cerrada
    };

    await this._restaurantService.updateOrder(json).then(
      (response) => {
        if (response.result) {            
          this._utilsService.showNotification(1, response.message);
          //this.orderActive = false;
        } else {
          this._utilsService.showNotification(3, response.errorMessage);
        }
      },
      error => {
        this._utilsService.showNotification(2, error);
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
      this.viewBeginning();
    });

  }

  async saveOrder() {
    // console.log('Guardando Orden');
    this.loading = true;
    this.payOrderButtonEnabled = true;

    //SI EXISTE ORDEN
    if(this.orderActive){

      let json = {
        "store": {
          "storeCode": this.storeCode
        },
        "user": {
          "userCode": this.userCode
        },
        "table": {
          "tableCode": this.mesaOrden
        },
        "detail": this.invoiceLine,
        "orderCode": this.orderID,
        "status": 1 //Abierta
      };

      await this._restaurantService.updateOrder(json).then(
        (response) => {
          if (response.result) {            
            this._utilsService.showNotification(1, response.message);
            this.orderActive = true;
          } else {
            this._utilsService.showNotification(3, response.errorMessage);
          }
        },
        error => {
          this._utilsService.showNotification(2, error);
          console.log(error);
        }
      ).finally(() => {
        this.loading = false;

        if(this.updateOrderFromPayment){
          this.updateOrderFromPayment = false;

          if(!this.closeOrder){
            this.paymentUnlock();
          }else{
            this.closeOrder = false;
          }
        }
      });

    }
    //SI ES NUEVA ORDEN
    else{
      this.maxCheckQuantity = this.invoiceDetail.invoiceDetailQuantity;

      let json = {
        "store": {
          "storeCode": this.storeCode
        },
        "user": {
          "userCode": this.userCode
        },
        "table": {
          "tableCode": this.mesaOrden
        },
        "checks": {
          "checksQuantity": this.maxCheckQuantity
        },
        "detail": this.invoiceLine,
      };

      await this._restaurantService.insertOrder(json).then(
        (response) => {
          // console.log('saverOrder',response)
          if (response.result) {            
            this._utilsService.showNotification(1, response.message);
            this.orderActive = true;
          } else {
            this._utilsService.showNotification(3, response.errorMessage);
          }
        },
        error => {
          this._utilsService.showNotification(2, error);
          console.log(error);
        }
      ).finally(() => {
        this.loading = false;
      });
    }

    console.log('Fin Guardando Orden');
  }

  addProductInCheck(product, checked){
    let check = this.productsByCheck;
    let copyOfProduct = {...product}
    // console.log(copyOfProduct)

    //ELIMINAR PRODUCTO DE CUENTA
    if(!checked){      
      for (let i = 0; i < check.length; i++) {
        if(check[i].description == product.description){
          check.splice(i,1);
          i = this.productsByCheck.length;
          this.amountToPay -= product.total
        }
      }
    }else{
      //AGREGAR PRODUCTO A CUENTA
      check = this.productsByCheck;
      copyOfProduct.inCheck = 0;
      check.push(copyOfProduct);

      this.amountToPay += product.total
    }

    console.log('amountToPay',this.amountToPay);
    this.amountToPay > 0 ? this.disabledPay = false : this.disabledPay = true;
  }

  selectAllProduct(){
    this.invoiceLine.forEach(productx =>{
      console.log('productx',productx);
      this.addProductInCheck(productx, true);
      this.isChecked = true;
    });
    this.all = true;
    this.disabledPay = false;
  }

  unselectAllProduct(){
    this.invoiceLine.forEach(productx =>{
      console.log('productx',productx);
      this.addProductInCheck(productx, false);
      this.isChecked = false;
    });
    this.all = false;
    this.disabledPay = true;
    this.amountToPay = 0;
  }

  goToPaymentMethods() {
    this.showOrderDetail = false;
    this.showPaymentMethods = true;
    this.isMoney = false;
  }

  goToInvoiceInformation() {
    this.showPaymentMethods = false;
    this.showInvoiceInfo = true;
  }

  backToPaymentMethods() {
    this.showInvoiceInfo = false;
    this.showPaymentMethods = true;
  }

  backToOrderDetail() {
    this.showPaymentMethods = false;
    this.showOrderDetail = true;
    this.productsByCheck = [];
    this.amountToPay = 0.00;
    this.MontoTotalPayment = 0.00;
    this.PaymentLine = [];
    
    this.invoiceLine.forEach(productx =>{
      console.log('productx',productx);
      this.addProductInCheck(productx, false);
      this.isChecked = false;
    });
    this.all = false;
    this.disabledPay = true;
  }

  addCheckClientNIT(checkNumber){
    this.checkClientNIT = parseInt(checkNumber);
  }

  async lockOrders() {
    this.PaymentStatus = false;
    this.divideInChecksEnabled = false;

    this.showPaymentMethods = false;
    this.showOrderDetail = true;
    this.productsByCheck = [];
    this.amountToPay = 0.00;
    this.MontoTotalPayment = 0.00;
    this.PaymentLine = [];
    
    this.invoiceLine.forEach(productx =>{
      console.log('productx',productx);
      this.addProductInCheck(productx, false);
      this.isChecked = false;
    });
    this.all = false;
    this.disabledPay = true;

    // document.getElementById('checksQuantityDropdown').innerHTML = `<option value=1>1</option>`;
    this.viewCategory();
  }

  getTablesList(code) {
    this.tablesList = [];
    return this._companyService.getTables(code).then(
      response => {
        if (response.result) {
          this.tablesList = response.records;
          console.log('Tables',this.tablesList);
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  public SKUx: string;
  async CargarSKU() {
    var sku;
    sku = this.SKUx;

    const SKUs = this.inventoryList.find(({ inventoryBusinessCode }) => inventoryBusinessCode === sku);
    console.log('SKU Buscado', SKUs);

    if(SKUs == undefined){
      this._utilsService.showNotification(2, 'Producto no disponible, validar stock en inventario');
    }
    else{

      if(sku.length > 3){
        //const _selectedItem = await this.inventoryList.find(x => x.id == sku);
        const _selectedItem = SKUs
        // console.log('----_selectedItem---', _selectedItem);
  
        //SI ES PETROLIO
        this.idp = 0;
        this.subIdp = 0;
        this.subsidioTemp = 0;
        this.isOil = null;
        this.petroleo = null;
        this.itemCode = _selectedItem.inventoryCode;
        this.invoiceDetail.invoiceDetailDescription = _selectedItem.itemName;
        this.invoiceDetail.invoiceDetailType = 'B';
        this.stock = _selectedItem.inventoryQuantity;
        this.Minstock = _selectedItem.inventoryMin;
  
        if (_selectedItem.inventorySerialFlag == 1) {
          this.loading = true;
          this.serialSelectedTemp = [];
          this.serialList = [];
          const response = await this._inventoryService.getItemSerial(this.itemCode);
          this.serialList = response.records[1];
  
          this.serial = true;
          this.loading = false;
        } else {
          this.serial = false
        }
  
        await this.saveLineInvoice();
        this.SKUx = "";      
      }
    }
  }

  public jumpSerial: boolean;
  async cargarTrasnferencia(code) {
    this.loading = true;
    this.isDisabled = true;
    this.disabled = true;

    await this._warehouseService.getOneTransfer(code).then(
      response => {
        this.transferCode = response.records[0].transferCode;
        this.transferDetail = response.records[0].detail;
      });

    for (const e of this.transferDetail) {
      const _selectedItem = await this.inventoryList.find(x => x.id == parseFloat(e.transferInventoryDetailInventoryCode));
      this.invoiceDetail.invoiceDetailType = 'B';
      this.itemCode = e.transferInventoryDetailInventoryCode;
      this.invoiceDetail.invoiceDetailQuantity = parseFloat(e.transferInventoryDetailQuantity);
      this.invoiceDetail.invoiceDetailDescription = _selectedItem.inventoryBusinessCode + ' - ' + e.transferInventoryDetailDescription;
      this.stock = _selectedItem.inventoryQuantity;
      this.priceType = 1;

      // Nuevo
      if (parseFloat(e.transferDetailType) === 1) {
        await this.saveLineInvoice();
      } else {
        let series = await this._warehouseService.getOneSerial(this.transferCode, e.transferInventoryDetailInventoryCode);
        for (const i of series.records[0].detail) {
          await this.serialSelected.push({
            serialCode: parseFloat(i.trasferSerialDetailSerialCode),
            inventorySerialSerial: i.trasferSerialDetailDescription
          });
          await this.serialSelectedTemp.push({
            serialCode: parseFloat(i.trasferSerialDetailSerialCode),
            inventorySerialSerial: i.trasferSerialDetailDescription
          });
        }
        this.jumpSerial = true;
        await this.saveLineInvoiceSerial();
        this.serialSelectedTemp = [];
      }
      this.jumpSerial = true;
    };

    this.loading = false;
    this.isDisabled = false;
    this.disabled = false;
  }

  onChangepaymentType(event) {
    this.invoiceHeader.paymentType = event;
    this.tipoPago = event;
  }

  ///////////////////////COMPANY///////////////////////
  getCompany(company) {
    return this._companyService.getOne(company).then(
      response => {
        if (response.result) {
          this.company = response.records[0];
          this.company.companyTaxToPay == 12 ? this.taxToPay = 1.12 : this.taxToPay = 1.05;
          this.company.companyTaxToPay == 12 ? this.regimenMessage = "Sujeto a pagos trimestrales ISR" : this.regimenMessage = "*No genera derecho a crédito fiscal";
          this.company.companyLogo != 'undefined' ? this.companyLogoUrl = this.company.companyLogoUrl : '';
          console.log('Company -> ', this.company);
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  ///////////////////////STORE///////////////////////
  getStore(store) {
    return this._storeService.getOne(store).then(
      response => {
        if (response.result) {
          this.store = response.records[0];
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  ///////////////////////SELECT///////////////////////
  getSelectSetting(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItems = [selected] : '';

    this.dropdownSettings = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'id',
      textField: 'itemName'
    };
  }

  getSelectSettingSerial(selected) {
    Object.keys(selected).length > 0 ? this.selectedItemsSerial = [selected] : '';

    this.dropdownSettingsSerial = {
      idField: 'InventorySerialCode',
      textField: 'inventorySerialSerial',
      itemsShowLimit: 3,
      enableCheckAll: false,
      singleSelection: false,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar",
    }
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  toggleCloseDropdownSelection() {
    this.closeDropdownSelection = !this.closeDropdownSelection;
    this.dropdownSettings = Object.assign({}, this.dropdownSettings, { closeDropDownOnSelection: this.closeDropdownSelection });
  }

  getInventoryList(code) {
    this.inventoryList = [];
    return this._inventoryService.getAllByStore(code).then(
      response => {
        if (response.result) {
          this.inventoryList = response.records;
          // console.log(this.inventoryList);
          // console.log("this.inventoryList ->" + code);
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  serial = false;
  async onItemSelect(item: any) {
    // console.log("---item---");
    // console.log(item);
    const _selectedItem = await this.inventoryList.find(x => x.id == item.id);

    //SI ES PETROLIO
    this.idp = 0;
    this.subIdp = 0;
    this.subsidioTemp = 0;
    this.isOil = null;
    this.petroleo = null;
    this.itemCode = item.id;
    this.invoiceDetail.invoiceDetailDescription = item.itemName;
    this.invoiceDetail.invoiceDetailType = 'B';
    this.stock = _selectedItem.inventoryQuantity;
    this.Minstock = _selectedItem.inventoryMin;

    if (_selectedItem.inventorySerialFlag == 1) {
      this.loading = true;
      this.serialSelectedTemp = [];
      this.serialList = [];
      const response = await this._inventoryService.getItemSerial(this.itemCode);
      this.serialList = response.records[1];

      this.serial = true;
      this.loading = false;
    } else {
      this.serial = false
    }
  }

  onItemSelectSerial(item: any) {
    this.serialSelected.push({
      serialCode: item.InventorySerialCode,
      inventorySerialSerial: item.inventorySerialSerial
    });

    this.serialSelectedTemp.push({
      serialCode: item.InventorySerialCode,
      inventorySerialSerial: item.inventorySerialSerial
    });
  }

  async onItemDeSelectSerial(item: any) {
    this.serialSelected.forEach((e, index) => {
      if (e.serialCode == item.InventorySerialCode)
        this.serialSelected.splice(index, 1);
    });

    this.serialSelectedTemp.forEach((i, indece) => {
      if (i.serialCode == item.InventorySerialCode)
        this.serialSelectedTemp.splice(indece, 1);
    });
  }

  ///////////////////////FUNCTION CHANGE COIN///////////////////////
  onChange(event) {
    this.invoiceHeader.invoiceCoin = event;

    if (this.invoiceHeader.invoiceCoin == 0) {
      this.moneda = "Q";
      this.invoiceHeader.invoiceCurrency = 'GTQ';
      this.invoiceHeader.invoiceExchangeRate = 0;
    } else if (this.invoiceHeader.invoiceCoin == 1) {
      this.moneda = "$"
      this.invoiceHeader.invoiceCurrency = 'USD';
    }
  }

  ///////////////////////FUNCTION CHANGE ORIGEN///////////////////////
  onChangeOrigen(event) {
    this.invoiceHeader.origenCompra = event;
  }

  ///////////////////////FUNCTION CHANGE PRICE///////////////////////
  onChangePrice(event) {
    this.priceType = parseFloat(event);
  }

  ///////////////////////FUNCTION VALIDATE DATE///////////////////////
  validateDate($event) {
    $event.preventDefault();
    var valid = false;
    var now = this.nowDay.split('-');
    var date = this.invoiceHeader.invoiceDate.split('-');

    if (date[0] == now[0] || parseFloat(date[0]) == parseFloat(now[0]) - 1) {
      if (date[1] == now[1]) {
        if (parseFloat(date[2]) <= parseFloat(now[2]) + 5 && parseFloat(date[2]) >= parseFloat(now[2]) - 5) {
          valid = true;
        }
      }
      else if (parseFloat(date[1]) == parseFloat(now[1]) - 1 || parseFloat(date[1]) == 12) {
        if (parseFloat(date[2]) >= 26) {
          valid = true;
        }
      }
    }

    if (valid == false) {
      this._utilsService.showNotification(2, 'Fecha fuera de rango')
      this.invoiceHeader.invoiceDate = this.nowDay;
    };
  }

  ///////////////////////FUNCTION CHANGE INTERAL SERIAL///////////////////////
  onChangeInternSerial(event) {
    this.invoiceHeader.invoiceInternSerial = event;
  }

  async savePropina(){

    //SI ES PETROLIO
    this.idp = 0;
    this.subIdp = 0;
    this.subsidioTemp = 0;
    this.isOil = null;
    this.petroleo = null;
    this.itemCode = "9999999";
    this.invoiceDetail.invoiceDetailDescription = "Propina";
    this.invoiceDetail.invoiceDetailType = 'B';
    this.stock = 1;
    this.Minstock = 999;
    this.invoiceDetail.invoiceDetailUnitPrice = this.Propina;
    this.invoiceDetail.invoiceDetailQuantity = 1;
    

    this.subIdp = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4));
    this.invoiceDetail.invoiceDetailSubtotal = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice).toFixed(4));
    this.invoiceDetail.invoiceDetailTax = parseFloat((this.invoiceDetail.invoiceDetailSubtotal - (this.invoiceDetail.invoiceDetailSubtotal / this.taxToPay)).toFixed(4));

    //Guardar Linea
    await this.invoiceLine.push({
      //Area de combustible
      subsidio: this.subsidioTemp,
      isOil: this.isOil,
      taxOilUP: this.idp,
      taxOilAmount: this.subIdp,
      taxOilName: this.petroleo,
      taxOilCode: this.taxOilCode,
      taxOilQuantity: this.invoiceDetail.invoiceDetailQuantity,
      itemCode: this.itemCode,
      measure: "UNI",
      taxCode: 1,
      taxName: "IVA",
      isService: this.invoiceDetail.invoiceDetailType,
      quantity: 1,
      description: this.invoiceDetail.invoiceDetailDescription,
      discount: 0,
      unitPrice: parseFloat(this.invoiceDetail.invoiceDetailUnitPrice.toFixed(4)),
      price: parseFloat((this.invoiceDetail.invoiceDetailSubtotal).toFixed(4)),
      taxAmount: parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(4)),
      taxableAmount: parseFloat((this.invoiceDetail.invoiceDetailSubtotal - this.invoiceDetail.invoiceDetailTax).toFixed(4)),
      total: parseFloat(((this.invoiceDetail.invoiceDetailSubtotal + (this.invoiceDetail.invoiceDetailQuantity * this.idp))).toFixed(4)),
      adds: [],
      commandStatus: "1"
    });
    this.subsidio += (this.invoiceDetail.invoiceDetailQuantity * this.subsidioTemp);
    this.invoiceHeader.invoiceIDP += parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4));
    this.invoiceHeader.invoiceTotal += parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4)))).toFixed(4));
    this.invoiceHeader.invoiceTax += parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(6));
    this.selectedItems = [];
    this.cleanLineInvoice();

  }

  // GUARDAR UNA LINEA DE COMPRA
  async saveLineInvoice() {
    this.isDisabled = true;
    this.disabled = true;

    if(this.company.companyCode == 24){ //Manejo de decimales ETISA

      if (this.invoiceDetail.invoiceDetailQuantity > 0) {

        //Actualizar?
        let update = false;
        // console.log("---invoiceLine---");
        // console.log(this.invoiceLine);
        // console.log("---invoiceDetail---");
        // console.log(this.invoiceDetail);
        // console.log("---itemCode---");
        // console.log(this.itemCode);
        for await (const e of this.invoiceLine) {
          if (e.itemCode == this.itemCode) {
            //Validacion
            let quantity;
            this.isEdit === true ? quantity = this.invoiceDetail.invoiceDetailQuantity : quantity = e.quantity + this.invoiceDetail.invoiceDetailQuantity;
  
            const response = await this._inventoryService.getPriceByItem(this.itemCode, quantity);
            switch (this.priceType) {
              case 1: this.invoiceDetail.invoiceDetailUnitPrice = response.records.precio;
                break;
              case 2: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryPriceDiscount;
                break;
              case 3: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventorySalePrice;
                break;
              case 4: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryminprice;
                break;
            }
  
            if (this.company.companyExistenceFlag === 1 || quantity <= this.stock) {
              //Restar Encabezado
              this.subsidio -= e.subsidio;            
              this.invoiceHeader.invoiceIDP -= parseFloat((e.taxOilAmount).toFixed(6));
              this.invoiceHeader.invoiceTotal -= parseFloat((e.total).toFixed(6));
              this.invoiceHeader.invoiceTax -= parseFloat((e.taxAmount).toFixed(6));
  
              //Realizar Calculos
              if (parseFloat(e.discount) > 0) {
                this.invoiceDetail.invoiceDetailSubtotal = parseFloat((quantity * this.invoiceDetail.invoiceDetailUnitPrice).toFixed(6));
                this.invoiceDetail.invoiceDetailSubtotal = parseFloat((this.invoiceDetail.invoiceDetailSubtotal - e.discount).toFixed(6));
                this.invoiceDetail.invoiceDetailTax = parseFloat((this.invoiceDetail.invoiceDetailSubtotal - (this.invoiceDetail.invoiceDetailSubtotal / this.taxToPay)).toFixed(6));
              } else {
                this.invoiceDetail.invoiceDetailDiscount = e.discount;
                this.invoiceDetail.invoiceDetailSubtotal = quantity * this.invoiceDetail.invoiceDetailUnitPrice;
                this.invoiceDetail.invoiceDetailTax = parseFloat((this.invoiceDetail.invoiceDetailSubtotal - (this.invoiceDetail.invoiceDetailSubtotal / this.taxToPay)).toFixed(6));
              }
  
              //Editar Linea
              e.quantity = quantity;
              e.unitPrice = this.invoiceDetail.invoiceDetailUnitPrice;
              e.price = parseFloat((this.invoiceDetail.invoiceDetailSubtotal).toFixed(6));
              e.taxAmount = parseFloat((this.invoiceDetail.invoiceDetailTax).toFixed(6));
              e.taxableAmount = parseFloat((this.invoiceDetail.invoiceDetailSubtotal - this.invoiceDetail.invoiceDetailTax).toFixed(6));
              e.taxOilAmount = parseFloat((quantity * this.idp).toFixed(6)),
              e.total = parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (parseFloat((quantity * this.idp).toFixed(6)))).toFixed(6)),
              e.taxOilQuantity = quantity;
              e.subsidio = (quantity * this.subsidioTemp);
  
              //Sumar Encabezado 
              this.subsidio += e.subsidio;
              this.invoiceHeader.invoiceIDP += parseFloat((quantity * this.idp).toFixed(6));
              this.invoiceHeader.invoiceTotal += parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (quantity * this.idp)).toFixed(6));
              this.invoiceHeader.invoiceTax += parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(6));
              this.selectedItems = [];
              this.cleanLineInvoice();
            } else {
              this._utilsService.showNotification(2, 'Cantidad Excede Exitencia');
            }
            update = true;
            this.isEdit = false;
            this.addAmount = false;
            this.isDisabled = false;
            this.disabled = false;
          }
        };
  
        //Nuevo Item
        if (this.addAmount === true && update === false) {
          const response = await this._inventoryService.getPriceByItem(this.itemCode, this.invoiceDetail.invoiceDetailQuantity);
          switch (this.priceType) {
            case 1: this.invoiceDetail.invoiceDetailUnitPrice = response.records.precio;
              break;
            case 2: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryPriceDiscount;
              break;
            case 3: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventorySalePrice;
              break;
            case 4: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryminprice;
              break;
          }
  
          this.subIdp = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(6));
          this.invoiceDetail.invoiceDetailSubtotal = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice).toFixed(6));
          this.invoiceDetail.invoiceDetailTax = parseFloat((this.invoiceDetail.invoiceDetailSubtotal - (this.invoiceDetail.invoiceDetailSubtotal / this.taxToPay)).toFixed(6));
  
          // console.log('linea subtotal ', this.invoiceDetail.invoiceDetailSubtotal);
          // console.log('linea unit ', this.invoiceDetail.invoiceDetailUnitPrice);
          //Validacion
          if (this.company.companyExistenceFlag === 1 || this.invoiceDetail.invoiceDetailQuantity <= this.stock) {                     
  
            //Guardar Linea
            await this.invoiceLine.push({
              //Area de combustible
              subsidio: this.subsidioTemp,
              isOil: this.isOil,
              taxOilUP: this.idp,
              taxOilAmount: this.subIdp,
              taxOilName: this.petroleo,
              taxOilCode: this.taxOilCode,
              taxOilQuantity: this.invoiceDetail.invoiceDetailQuantity,
              itemCode: this.itemCode,
              measure: "UNI",
              taxCode: 1,
              taxName: "IVA",
              isService: this.invoiceDetail.invoiceDetailType,
              quantity: this.invoiceDetail.invoiceDetailQuantity,
              description: this.invoiceDetail.invoiceDetailDescription,
              discount: 0,
              unitPrice: parseFloat(this.invoiceDetail.invoiceDetailUnitPrice.toFixed(6)),
              price: parseFloat((this.invoiceDetail.invoiceDetailSubtotal).toFixed(6)),
              taxAmount: parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(6)),
              taxableAmount: parseFloat((this.invoiceDetail.invoiceDetailSubtotal - this.invoiceDetail.invoiceDetailTax).toFixed(6)),
              total: parseFloat(((this.invoiceDetail.invoiceDetailSubtotal + (this.invoiceDetail.invoiceDetailQuantity * this.idp))).toFixed(6)),
              adds: [],
              commandStatus: "0"
            });
            this.subsidio += (this.invoiceDetail.invoiceDetailQuantity * this.subsidioTemp);
            this.invoiceHeader.invoiceIDP += parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(6));
            this.invoiceHeader.invoiceTotal += parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(6)))).toFixed(6));
            this.invoiceHeader.invoiceTax += parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(6));
            this.selectedItems = [];
            this.cleanLineInvoice();
          } else {
            this._utilsService.showNotification(2, 'Cantidad Excede Exitencia');
          }
          this.isDisabled = false;
          this.disabled = false;
        }
      } else {
        this._utilsService.showNotification(2, "Ingresa una cantidad")
      }
      this.addAmount = true;
      this.isDisabled = false;
      this.disabled = false;
      this.ValidarCF();

    }
    else{ //Resto de empresas que no manejan decimales

      if (this.invoiceDetail.invoiceDetailQuantity > 0) {

        //Actualizar?
        let update = false;
        // console.log("---invoiceLine---");
        // console.log(this.invoiceLine);
        // console.log("---invoiceDetail---");
        // console.log(this.invoiceDetail);
        // console.log("---itemCode---");
        // console.log(this.itemCode);
  
        //Nuevo Item
        if (this.addAmount === true && update === false) {
          console.log('this.inventoryPriceDefault',this.inventoryPriceDefault);
          const response = await this._inventoryService.getPriceByItem(this.itemCode, this.invoiceDetail.invoiceDetailQuantity);
          console.log('precio responde',response);
          switch (this.inventoryPriceDefault) {
            case 1: this.invoiceDetail.invoiceDetailUnitPrice = response.records.precio;
              break;
            case 4: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventorySalePrice;
              break;
            case 3: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryPriceDiscount;
              break;
            case 2: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryminprice;
              break;
          }
  
          this.subIdp = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4));
          this.invoiceDetail.invoiceDetailSubtotal = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice).toFixed(4));
          this.invoiceDetail.invoiceDetailTax = parseFloat((this.invoiceDetail.invoiceDetailSubtotal - (this.invoiceDetail.invoiceDetailSubtotal / this.taxToPay)).toFixed(4));
  
          console.log('linea subtotal ', this.invoiceDetail.invoiceDetailSubtotal);
          console.log('linea unit ', this.invoiceDetail.invoiceDetailUnitPrice);
          //Validacion
          if (this.company.companyExistenceFlag === 1 || this.invoiceDetail.invoiceDetailQuantity <= this.stock) {
  
            let DifInventario = this.stock - this.invoiceDetail.invoiceDetailQuantity;

            console.log(DifInventario, this.stock, this.invoiceDetail.invoiceDetailQuantity);
            console.log(this.Minstock);   

            if(this.company.companyExistenceFlag === 0 && DifInventario <= this.Minstock){
              this._utilsService.showNotification(2, 'El STOCK MINIMO ha llegado a su limite configurado.');
              //enviar correo
            }

            //Guardar Linea
            await this.invoiceLine.push({
              //Area de combustible
              subsidio: this.subsidioTemp,
              isOil: this.isOil,
              taxOilUP: this.idp,
              taxOilAmount: this.subIdp,
              taxOilName: this.petroleo,
              taxOilCode: this.taxOilCode,
              taxOilQuantity: this.invoiceDetail.invoiceDetailQuantity,
              itemCode: this.itemCode,
              measure: "UNI",
              taxCode: 1,
              taxName: "IVA",
              isService: this.invoiceDetail.invoiceDetailType,
              quantity: this.invoiceDetail.invoiceDetailQuantity,
              description: this.invoiceDetail.invoiceDetailDescription,
              discount: 0,
              unitPrice: parseFloat(this.invoiceDetail.invoiceDetailUnitPrice.toFixed(4)),
              price: parseFloat((this.invoiceDetail.invoiceDetailSubtotal).toFixed(4)),
              taxAmount: parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(4)),
              taxableAmount: parseFloat((this.invoiceDetail.invoiceDetailSubtotal - this.invoiceDetail.invoiceDetailTax).toFixed(4)),
              total: parseFloat(((this.invoiceDetail.invoiceDetailSubtotal + (this.invoiceDetail.invoiceDetailQuantity * this.idp))).toFixed(4)),
              adds: [],
              commandStatus: "0"
            });
            this.subsidio += (this.invoiceDetail.invoiceDetailQuantity * this.subsidioTemp);
            this.invoiceHeader.invoiceIDP += parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4));
            this.invoiceHeader.invoiceTotal += parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4)))).toFixed(4));
            this.invoiceHeader.invoiceTax += parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(6));
            this.selectedItems = [];
            this.cleanLineInvoice();
          } 
          else {
            this._utilsService.showNotification(2, 'Cantidad Excede Exitencia');
          }
          this.isDisabled = false;
          this.disabled = false;
        }
      } else {
        this._utilsService.showNotification(2, "Ingresa una cantidad")
      }
      this.addAmount = true;
      this.isDisabled = false;
      this.disabled = false;
      this.ValidarCF();
      this.Pagado();

    }

    
  }

  // GUARDAR LINEA CON SERIES
  async saveLineInvoiceSerial() {
    this.isDisabled = true;
    this.disabled = true;    

    let res_find = await this.invoiceLine.find(x => x.itemCode === this.itemCode);

    if (!res_find) {
      if (this.invoiceDetail.invoiceDetailQuantity == this.serialSelectedTemp.length) {

        if (!this.jumpSerial) {
          this.invoiceDetail.invoiceDetailDescription += ' SERIES: ';
          for await (const e of this.serialSelectedTemp) {
            this.invoiceDetail.invoiceDetailDescription += e.inventorySerialSerial + ', ';
          }
        }

        const response = await this._inventoryService.getPriceByItem(this.itemCode, this.invoiceDetail.invoiceDetailQuantity);
        switch (this.priceType) {
          case 1: this.invoiceDetail.invoiceDetailUnitPrice = response.records.precio;
            break;
          case 2: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryPriceDiscount;
            break;
          case 3: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventorySalePrice;
            break;
          case 4: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryminprice;
            break;
        }

        this.subIdp = 0;
        this.invoiceDetail.invoiceDetailSubtotal = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice).toFixed(4));
        this.invoiceDetail.invoiceDetailTax = parseFloat((this.invoiceDetail.invoiceDetailSubtotal - (this.invoiceDetail.invoiceDetailSubtotal / this.taxToPay)).toFixed(4));

        await this.invoiceLine.push({
          //Area de Serie
          serial: this.serialSelectedTemp,
          //Area de combustible
          isOil: this.isOil,
          taxOilUP: this.idp,
          taxOilAmount: this.subIdp,
          taxOilName: this.petroleo,
          taxOilCode: this.taxOilCode,
          taxOilQuantity: this.invoiceDetail.invoiceDetailQuantity,
          itemCode: this.itemCode,
          measure: "UNI",
          taxCode: 1,
          taxName: "IVA",
          isService: this.invoiceDetail.invoiceDetailType,
          quantity: this.invoiceDetail.invoiceDetailQuantity,
          description: this.invoiceDetail.invoiceDetailDescription,
          discount: 0,
          unitPrice: parseFloat(this.invoiceDetail.invoiceDetailUnitPrice.toFixed(4)),
          price: parseFloat((this.invoiceDetail.invoiceDetailSubtotal).toFixed(4)),
          taxAmount: parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(4)),
          taxableAmount: parseFloat((this.invoiceDetail.invoiceDetailSubtotal - this.invoiceDetail.invoiceDetailTax).toFixed(4)),
          total: parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (this.invoiceDetail.invoiceDetailQuantity * this.idp)).toFixed(4)),
        });
        this.invoiceHeader.invoiceIDP += parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4));
        this.invoiceHeader.invoiceTotal += parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4)))).toFixed(4));
        this.invoiceHeader.invoiceTax += parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(4));
        this.cleanLineInvoice();

      } else {
        this._utilsService.showNotification(2, 'Por favor revisa las cantidad de series seleccionadas');
      }
    } else {
      this._utilsService.showNotification(3, 'Item ya ingresado, por favor eliminalo antes.');
    }
    this.isDisabled = false;
    this.disabled = false;
  }

  // APLICAR DESCUENTO EN TIEMPO REAL
  ApplyDiscount($event, item, descuento) {
    $event.preventDefault();

    if(this.company.companyCode == 24){ //Manejo de decimales ETISA
      
      this.invoiceLine.forEach((e) => {
        if (e.itemCode == item) {
          let temporal = parseFloat(e.quantity) * parseFloat(e.unitPrice);
  
          if (parseFloat(descuento) <= temporal) {
            this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal - parseFloat(e.total)).toFixed(6));
            this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax - parseFloat(e.taxAmount)).toFixed(6));
            e.total = parseFloat((temporal - parseFloat(descuento)).toFixed(6));
            e.taxAmount = parseFloat((parseFloat(e.total) - (parseFloat(e.total) / this.taxToPay)).toFixed(6));
            e.taxableAmount = parseFloat((parseFloat(e.total) - parseFloat(e.taxAmount)).toFixed(6));
            this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal + parseFloat(e.total)).toFixed(6));
            this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax + parseFloat(e.taxAmount)).toFixed(6));
          } else {
            this._utilsService.showNotification(2, "Cantidad No permitida");
          }
        }
      });
      
    }
    else{
      this.invoiceLine.forEach((e) => {
        if (e.itemCode == item) {
          let temporal = parseFloat(e.quantity) * parseFloat(e.unitPrice);

          let DifInventario = this.stock - e.quantity;

          if(this.company.companyExistenceFlag === 0 && DifInventario <= this.Minstock){
            this._utilsService.showNotification(2, 'El STOCK MINIMO ha llegado a su limite configurado.');
            //enviar correo
          }
  
          if (parseFloat(descuento) <= temporal) {
            this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal - parseFloat(e.total)).toFixed(4));
            this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax - parseFloat(e.taxAmount)).toFixed(4));
            e.total = parseFloat((temporal - parseFloat(descuento)).toFixed(4));
            e.taxAmount = parseFloat((parseFloat(e.total) - (parseFloat(e.total) / this.taxToPay)).toFixed(4));
            e.taxableAmount = parseFloat((parseFloat(e.total) - parseFloat(e.taxAmount)).toFixed(4));
            this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal + parseFloat(e.total)).toFixed(4));
            this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax + parseFloat(e.taxAmount)).toFixed(4));
          } else {
            this._utilsService.showNotification(2, "Cantidad No permitida");
          }
        }
      });
    }    

    this.ValidarCF();
  }

  ApplyQuantity($event, item, cantidad){
    $event.preventDefault();

    this.invoiceLine.forEach((e) => {
      if (e.itemCode == item) {
        let temporal = parseFloat(e.quantity) * parseFloat(e.unitPrice);

        if (cantidad > 0) {
          this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal - parseFloat(e.total)).toFixed(4));
          this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax - parseFloat(e.taxAmount)).toFixed(4));
          e.total = parseFloat((temporal).toFixed(4));
          e.taxAmount = parseFloat((parseFloat(e.total) - (parseFloat(e.total) / this.taxToPay)).toFixed(4));
          e.taxableAmount = parseFloat((parseFloat(e.total) - parseFloat(e.taxAmount)).toFixed(4));
          this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal + parseFloat(e.total)).toFixed(4));
          this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax + parseFloat(e.taxAmount)).toFixed(4));
        } else {
          this._utilsService.showNotification(2, "Cantidad No permitida");
        }
      }
    });

    this.ValidarCF();    
  }

  // ELIMINAR UNA LINEA
  async deleteLine(itemCodeSelected) {
    this.isDisabled = true;
    this.disabled = true;
    let oneItemDeleted = false;

    await this.invoiceLine.forEach(async (e, index) => {
      if ((e.itemCode === itemCodeSelected) && !oneItemDeleted) {
        if (e.taxOilName != undefined) {          
          this.subsidio -= parseFloat(e.subsidio);
          this.invoiceHeader.invoiceIDP = this.invoiceHeader.invoiceIDP - parseFloat(e.taxOilAmount);
        }

        if (e.serial) {
          for (const i of e.serial) {
            let indice = this.serialSelected.findIndex(x => x.serialCode === i.serialCode);
            this.serialSelected.splice(indice, 1);
          };
        }

        this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal - parseFloat(e.price)).toFixed(4));
        this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax - parseFloat(e.taxAmount)).toFixed(4));
        this.invoiceLine.splice(index, 1);
        oneItemDeleted = true;
        this.updateOrderFromPayment = true;
      }
    });
    this.cleanLineInvoice();
    this.isDisabled = false;
    this.disabled = false;
    this.Pagado();
  }

  // LIMPIAR LINEA PARA NUEVO INGRESO
  cleanLineInvoice() {
    this.jumpSerial = false;
    this.isDisabled = false;
    this.disabled = false;
    this.addAmount = true;
    this.priceType = 1;
    this.isEdit = false;
    this.serial = false;
    this.selectedItemsSerial = null;
    this.selectedItems = [];
    this.invoiceDetail = {} as InvoiceDetail;
    this.invoiceDetail.invoiceDetailQuantity = 1;
  }

  onChangeTypeClient(event) {    
    this.client.clientType = event;
    this.tipoCliente = event;
    console.log('----->', this.tipoCliente);

    if(event == 2){
      this.disabledEXT = false;
      this.client.clientName = "";
      this.client.clientTaxDocument = "";
    }
    else{
      this.disabledEXT = true;
      this.client.clientName = "";
      this.client.clientTaxDocument = "";
    }
  }

  ///////////////////////Funcion de Buscar por NIT///////////////////////
  buscarNITLocal($event, nit) {
    $event.preventDefault();
    this.isDisabled = true;
    this.disabled = true;
    this.loading = true;

    //FACTURAR CON PASAPORTE
    if(this.client.clientType == 2){
      this.client.clientName = this.client.clientName;
      this.client.clientStatus = 1;
      this.client.clientDeleted = 0;
      this.client.clientPhone = "00000000";
      this.client.clientEmail = "info@clever.com";
      this.client.clientAddress = "CIUDAD";

      this.insertNewClient = false;
      this.recurrentClient = false;
      this.viewBilling();
      this._utilsService.showNotification(4, "SE EMITIRA FACTURA CON PASAPORTE");
      this.loading = false;
      this.client.clientType = 2;
      this.tipoCliente = 2;

      this.isDisabled =false;

    }
    //FACTURAR CON NIT
    else{
      //DATOS PARA CF
      if(nit == "CF"){
        this.client.clientType = 0;
        this.tipoCliente = 0;
      }
      // return this._clientService.getOneByNit(nit).then(
      return this._clientService.getOneByCompanyNit(this.companyCode, nit).then(
        response => {
          // console.log(response.records)
          if (response.records.length > 0) {
            // this.addPaymentMethodEnabled = true;
            this.client = response.records[0];
            this.recurrentClient = true;
            this.insertNewClient = false;
            this.viewBilling();
            this._utilsService.showNotification(1, response.message);
            // this.PaymentLine[this.checkClientNIT-1] = {...this.client};
          } else {
            return this._clientService.searchNitSAT(nit, this.client.clientType).then(
              async response => {
                if (response.tipo_respuesta == 0) {
                  //this.client.clientName = response.nombre[0];
                  //console.log(response.nombre[0]);
                  // this.addPaymentMethodEnabled = true;
                  this.client.clientName =  response.nombre[0];
                  this.client.clientStatus = 1;
                  this.client.clientDeleted = 0;
                  this.client.clientPhone = "00000000";
                  this.client.clientEmail = "info@clever.com";
                  this.client.clientAddress = "CIUDAD";

                  this.insertNewClient = true;
                  this.recurrentClient = false;
                  this.viewBilling();
                  this._utilsService.showNotification(4, "Cliente Nuevo");
                  // this.PaymentLine[this.checkClientNIT-1] = {...this.client};
                } else {
                  this._utilsService.showNotification(3, response.listado_errores[0].error[0].desc_error[0]);
                  // this.addPaymentMethodEnabled = false;
                }
              },
              error => {
                console.log(error);
                // this.addPaymentMethodEnabled = false;
              }
            );
          }
        },
        error => {
          console.log(error);
          // this.addPaymentMethodEnabled = false;
        }
      ).finally(() => {
        this.loading = false;
        this.isDisabled = false;

        console.log('checkQuantitySelected',this.checkQuantitySelected);
        console.log('this.divideInChecksEnabled',this.divideInChecksEnabled);
        if(this.checkQuantitySelected != 1 || this.divideInChecksEnabled == true){
          this.client.clientTaxDocument = "";
          this.client.clientName = "";
        }

        this.ValidarCF();
      });
    }
  }  

  async insertInvoice(typeDoc) {
    this.loading = true;
    this.isDisabled = true;
    this.disabled = true;
    const _data = JSON.parse(localStorage.getItem('data'));

    let checkTax = 0;
    let checkTotal = 0;
    let closeOrder = 0;
    (this.productsByCheck.length == this.invoiceLine.length) ? closeOrder = 0 : closeOrder = 1;
    (this.productsByCheck.length == this.invoiceLine.length) ? this.closeOrderComplete = true : this.closeOrderComplete = false;

    this.productsByCheck.forEach(product => {
      checkTax += product.taxAmount;
      checkTotal += product.total;
    });  

    if(_data != undefined && !_data.isStoreOpen && this.OpenCash){
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se puede realizar una venta hasta que abra la caja....',
      })
      this.loading = false;
      return;
    }    

    if(typeDoc == 3){
      this.phoneWhastapp.toString().replace('-', '');
      this.phoneWhastapp.toString().replace(' ', '');
      if(this.phoneWhastapp.toString().length < 8){
        swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Debe de ingresar un número de telefono valido',
        })
        this.loading = false;
        return;
      }
    }    

    // console.log('TipoCliente -> ', this.tipoCliente);

    //Crear Cliente en la DB
    if (this.insertNewClient) {
      // Resolver problema con DATA BASE
      let nombre;
      nombre = this.client.clientName.replace(/&/g, '&amp;');
      nombre = this.client.clientName.replace(/'/g, '&apos;');
      nombre = this.client.clientName.replace(/"/g, '&quot;');

      this.client.clientName = nombre;
      this.client.clientCredit = 0;
      this.client.clientStatus = 1;
      this.client.clientDeleted = 0;
      this.client.clientBlocked = 0;
      this.client.clientInterest = 0;
      this.client.clientDiscount = 0;
      this.client.clientCategory = 2;
      this.client.clientCreditTime = 0;
      this.client.clientCreditAmount = 0;
      this.client.clientCompanyCode = this.companyCode;
      this.client.clientType = this.tipoCliente;
      this.client.clientNameFrequent = '-';

      if (this.client.clientTaxDocument && this.client.clientName) {
        const response = await this._clientService.insert(this.client);
        this.client.clientCode = response.records[0].insertId;
      };
    }

    // Si es factura de pequeño contribuyente
    let transmitterType = "FACT";
    let transmitterMembership = "GEN";
    if (this.company.companyTaxToPay == 5) {
      transmitterType = "FPEQ";
      transmitterMembership = "PEQ";
    }

    if (this.invoiceHeader.invoiceIDP > 0) {
      this.invoiceHeader.invoiceTax = 0;
      this.invoiceLine.forEach(e => {
        this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax + e.taxAmount).toFixed(4))
      });
    } else {
      this.invoiceHeader.invoiceTax = parseFloat(((this.invoiceHeader.invoiceTotal / this.taxToPay) * (this.taxToPay - 1)).toFixed(4))
    }   

    const hour = await this._utilsService.dateTime('HH:mm:ss');

    let FormaPagoTexto = "";
    if(this.tipoPago == 0){
      FormaPagoTexto = "Efectivo";
    }
    else if(this.tipoPago == 1){
      FormaPagoTexto = "Tarjeta";
    }
    else if(this.tipoPago == 1){
      FormaPagoTexto = "Crédito";
    }

    if(this.company.companyPaymentType == 0){
      await this.PaymentLine.push({
        typePayment: 0,
        NamePaymentType: 'Efectivo',
        MontoPayment: parseFloat((0).toFixed(4))
      });
    }

    let ADENDASUMMARY = undefined;

    let json = {
      "store": {
        "storeCode": this.storeCode
      },
      "user": {
        "userCode": this.userCode
      },
      "transmitter": {
        "transmitterMembership": transmitterMembership,
        "transmitterType": transmitterType,
        "transmitterEstablishmentCode": this.store.storeEstablishmentCode,
        "transmitterEmail": this.company.companyEmail,
        "transmitterTaxDocument": this.company.companyTaxDocument,
        "transmitterComercialName": this.store.storeName,
        "transmitterName": this.company.companyName,
        "transmitterAddress": this.store.storeAddress,
        "transmitterZipCode": this.store.storeZipCode,
        "transmitterMunicipality": this.store.storeMunicipality,
        "transmitterDepartment": this.store.storeDepartment,
        "transmitterCountry": 'GT',
        "transmitterPrefix": this.company.companyPrefix,
        "transmitterUser": this.company.companyPrefix,
        "transmitterKey": this.company.companyKey,
        "transmitterToken": this.company.companyToken,
        "transmitterPhraseCode": parseFloat(this.company.companyPhraseCode),
        "transmitterPhraseType": parseFloat(this.company.companyPhraseType),
        "transmitterPhone": this.company.companyPhone
      },
      "receiver": {
        "receiverAddress": this.client.clientAddress,
        "receiverCode": this.client.clientCode,
        "receiverDeleted": 0,
        "receiverEmail": this.client.clientEmail,
        "receiverName": this.client.clientName,
        "receiverStatus": 1,
        "receiverTaxDocument": this.client.clientTaxDocument,
        "receiverTypeTaxDocument": this.tipoCliente,
        "receiverZipCode": 0,
        "receiverCountry": "GT"
      },
      "invoice": {
        "invoiceCode": 1,
        "invoiceCurrency": this.invoiceHeader.invoiceCurrency,
        "invoiceChangeRate": this.invoiceHeader.invoiceExchangeRate == undefined ? 0 : this.invoiceHeader.invoiceExchangeRate,
        "invoiceTaxShortName": "IVA",
        // "invoiceDate": this.invoiceHeader.invoiceDate,
        "invoiceDate": this.invoiceHeader.invoiceDate + ' ' + hour,
        "invoiceInternSerial": this.invoiceHeader.invoiceInternSerial,
        "invoiceTaxValue": parseFloat((checkTax).toFixed(4)), //parseFloat((this.invoiceHeader.invoiceTax).toFixed(4)),
        "invoiceTotal": parseFloat((checkTotal).toFixed(4)), //parseFloat((this.invoiceHeader.invoiceTotal).toFixed(4)),
        "invoiceOilTaxShortName": this.invoiceHeader.invoiceIDP > 0 ? "PETROLEO" : undefined,
        "invoiceOilTaxValue": parseFloat((this.invoiceHeader.invoiceIDP).toFixed(4)),
        "invoiceDuesQuantity": 0,
        "invoicepaymentType": this.tipoPago,
        "origenCompra": this.invoiceHeader.origenCompra
      },
      "phrase": this.company.phrase,
      "detail": this.productsByCheck, //this.invoiceLine,
      "paymentType": this.PaymentLine,
      "provider": this.company.companyCertifier == 0 ? "infile" : "megaprint",
      "serial": this.serialSelected,
      "addendum": ADENDASUMMARY,
      "salesPerson": this.SalesPerson
    };

    const logo = await this._companyService.getOne(this.companyCode);
    logo.records[0].companyLogoUrl != 'undefined' && (this.companyLogoUrl = logo.records[0].companyLogoUrl);

    // console.log('Store', this.store);

    // Insertar Venta
    if(typeDoc == 1 || typeDoc == 3) { //Emite Factura

      //INFILE
      if (this.company.companyCertifier == 0) {
        this._invoiceService.insertBilling(json).then(
          async (response) => {
            if (response.result) {
              if(this.orderActive){

                // console.log('Actualizar Orden');
                this.productsByCheck.forEach(async product => {
                  await this.deleteLine(product.itemCode);
                });

                let json = {
                  "store": {
                    "storeCode": this.storeCode
                  },
                  "user": {
                    "userCode": this.userCode
                  },
                  "table": {
                    "tableCode": this.mesaOrden
                  },
                  "detail": this.invoiceLine,
                  "orderCode": this.orderID,
                  "status": closeOrder // 0 Cerrada
                };

                this._restaurantService.updateOrder(json).then(
                  (response) => {
                    if (response.result) {
                      this._utilsService.showNotification(1, response.message);
                      this.cleanModel();
                    } else {
                      this._utilsService.showNotification(3, response.errorMessage);
                    }
                  },
                  error => {
                    this._utilsService.showNotification(2, error);
                    console.log(error);
                  }
                ).finally(() => {
                  this.loading = false;
                });
              }

              // console.log("COMPANY: ", this.company);
              this.showInvoiceInfo = false;

              if (this.company.companyPDFType == 1) { //Formato Clever

                console.log("IMPRIME LOCAL");
                this.fel = response.infileBody;
                this.felDetail = response.infileBody.detail;
                this.dte = {
                  serie: response.records.infileServiceResponse.registerResponse.serie,
                  noFactura: response.records.infileServiceResponse.registerResponse.numero,
                  autorizacion: response.invoiceAuthorization,
                  certificador: "INFILE, S.A.",
                  nitCertificador: 12521337,
                  fechaCertificacion: response.records.infileServiceResponse.registerResponse.fecha
                }
                this.viewPrint(typeDoc);

                // if(closeOrder == 0){
                //   this.viewBeginning();
                //   this.cleanModel();
                //   this.closeOrder = true;
                // }

                if(this.closeOrderComplete){ //Limpiar
                  await this.viewBeginning();
                  this.cleanModel();
                  this.closeOrder = true;
                  console.log('Limpia pantalla orden finalizada factura local infile');
                }
                else{
                  console.log('Limpia pantalla orden abierta infile local');
                  await this.viewBeginning();
                }

                this.productsByCheck = [];
              } 
              else { // formato certificador

                console.log("IMPRIME COMO CARTA CERTIFICADOR");
                let uuid = response.invoiceAuthorization;
                window.open('https://report.feel.com.gt/ingfacereport/ingfacereport_documento?uuid=' + uuid, 'popup', 'width=600,height=600');

                if(typeDoc == 3){
                  let urlfactura = 'https://report.feel.com.gt/ingfacereport/ingfacereport_documento?uuid=' + uuid;
                  // let urlwhastapp = 'https://web.whatsapp.com/send?phone=+502' + this.phoneWhastapp + '&text= Hola ' + this.client.clientName + ', te compartimos tu factura electrónica. ' + urlfactura;
                  let urlwhastapp = 'https://api.whatsapp.com/send/?phone=+502' + this.phoneWhastapp + '&text=Hola ' + this.client.clientName + ', te compartimos tu factura electrónica. ' + urlfactura;

                  window.open(urlwhastapp,'_blank');
                }                

                if(this.closeOrderComplete){ //Limpiar
                  await this.viewBeginning();
                  this.cleanModel();
                  this.closeOrder = true;
                  console.log('Limpia pantalla orden finalizada factura infile certificador');
                }
                else{
                  console.log('Limpia pantalla orden abierta infile');
                  await this.viewBeginning();
                }

                this.productsByCheck = [];
              }
              this._utilsService.showNotification(1, response.message);
            } 
            else
            {
              this._utilsService.showNotification(3, response.errorMessage);
            }
          },
          error => {
            this._utilsService.showNotification(2, error);
            console.log(error);
          }
        ).finally(() => {
          this.loading = false;
          this.isDisabled = false;
          this.disabled = false;        
        });
      }
      //Megaprint
      else if (this.company.companyCertifier == 1) {
        this._invoiceService.insertBilling(json).then(
          async (response) => {
            if (response.result) {

              if(this.orderActive){ //cerrar orden

                // console.log('Actualizar Orden');
                this.productsByCheck.forEach(async product => {
                  await this.deleteLine(product.itemCode);
                });

                let json = {
                  "store": {
                    "storeCode": this.storeCode
                  },
                  "user": {
                    "userCode": this.userCode
                  },
                  "table": {
                    "tableCode": this.mesaOrden
                  },
                  "detail": this.invoiceLine,
                  "orderCode": this.orderID,
                  "status": closeOrder //0 Cerrada
                };
          
                this._restaurantService.updateOrder(json).then(
                  (response) => {
                    if (response.result) {            
                      this._utilsService.showNotification(1, response.message);
                      // 
                    } else {
                      this._utilsService.showNotification(3, response.errorMessage);
                    }
                  },
                  error => {
                    this._utilsService.showNotification(2, error);
                    console.log(error);
                  }
                ).finally(() => {
                  this.loading = false;   
                });
              }

              this.showInvoiceInfo = false;

              // console.log(response);
              if (this.company.companyInvoiceFuel == 1 || this.company.companyPDFType == 1) {
                this.fel = response.megaprintBody;
                this.felDetail = response.megaprintBody.detail;
                let dte = response.records.megaprintServiceResponse.jsonXml['dte:GTDocumento']['dte:SAT'][0]['dte:DTE'][0]['dte:Certificacion'][0];
                this.dte = {
                  serie: dte['dte:NumeroAutorizacion'][0]['Serie'][0],
                  noFactura: dte['dte:NumeroAutorizacion'][0]['Numero'][0],
                  autorizacion: dte['dte:NumeroAutorizacion'][0]['_'],
                  certificador: dte['dte:NombreCertificador'][0],
                  nitCertificador: dte['dte:NITCertificador'][0],
                  fechaCertificacion: dte['dte:FechaHoraCertificacion'][0]
                }
                this.viewPrint(typeDoc);

                // if(closeOrder == 0){
                //   this.viewBeginning();
                //   this.cleanModel();
                //   this.closeOrder = true;
                // }

                if(this.closeOrderComplete){ //Limpiar
                  await this.viewBeginning();
                  this.cleanModel();
                  this.closeOrder = true;
                  console.log('Limpia pantalla orden finalizada megaprint local');
                }
                else{
                  await this.viewBeginning();
                  console.log('Limpia pantalla orden abierta megaprint local');
                }

                this.productsByCheck = [];
              }
              else
              {
                var pdfResult = response.invoicePdf;
                let pdfWindow = window.open("")
                pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe>")
                
                if(this.closeOrderComplete){ //Limpiar
                  await this.viewBeginning();
                  this.cleanModel();
                  this.closeOrder = true;
                  console.log('Limpia pantalla orden finalizada megaprint certificador');
                }
                else{
                  await this.viewBeginning();
                  console.log('Limpia pantalla orden abierta');
                }
                
                this.productsByCheck = [];
              }
              this._utilsService.showNotification(1, response.message);
            } else {
              this._utilsService.showNotification(3, response.errorMessage);
            }
          },
          error => {
            this._utilsService.showNotification(2, error);
            console.log(error);
          }
        ).finally(() => {
          this.loading = false;
          this.isDisabled = false;
          this.disabled = false;
        });
      }

    }
    else if(typeDoc == 2) { //Emite Recibo

      this._invoiceService.insertBillingReceipt(json).then(
        async (response) => {
          if (response.result) {
            // console.log(response);
            if (this.company.companyInvoicePrint == 1) { //Ticket

              console.log('Respuesta Recibo Ticket 1 Cuenta -> ', response.megaprintBody);
              this.fel = response.megaprintBody;
              this.felDetail = response.megaprintBody.detail;
              //let dte = response.records.megaprintServiceResponse.jsonXml['dte:GTDocumento']['dte:SAT'][0]['dte:DTE'][0]['dte:Certificacion'][0];
              // this.dte = {
              //   serie: dte['dte:NumeroAutorizacion'][0]['Serie'][0],
              //   noFactura: dte['dte:NumeroAutorizacion'][0]['Numero'][0],
              //   autorizacion: dte['dte:NumeroAutorizacion'][0]['_'],
              //   certificador: dte['dte:NombreCertificador'][0],
              //   nitCertificador: dte['dte:NITCertificador'][0],
              //   fechaCertificacion: dte['dte:FechaHoraCertificacion'][0]
              // }

              if(this.orderActive){

                // console.log('Actualizar Orden');
                this.productsByCheck.forEach(async product => {
                  await this.deleteLine(product.itemCode);
                });

                let json = {
                  "store": {
                    "storeCode": this.storeCode
                  },
                  "user": {
                    "userCode": this.userCode
                  },
                  "table": {
                    "tableCode": this.mesaOrden
                  },
                  "detail": this.invoiceLine,
                  "orderCode": this.orderID,
                  "status": closeOrder //Cerrada
                };
          
                await this._restaurantService.updateOrder(json).then(
                  (response) => {
                    if (response.result) {            
                      this._utilsService.showNotification(1, response.message);
                      // 
                      this.productsByCheck = [];
                      this.showInvoiceInfo = false;
                      this.viewPrint(typeDoc);
                    } else {
                      this._utilsService.showNotification(3, response.errorMessage);
                    }
                  },
                  error => {
                    this._utilsService.showNotification(2, error);
                    console.log(error);
                  }
                ).finally(() => {
                  this.loading = false;   
                });                
              }              

              // if(closeOrder == 0){ //Limpiar Ticket
              //   this.viewBeginning();
              //   this.cleanModel();
              //   this.closeOrder = true;
              // }
            } 
            else
            { //Carta

              // var pdfResult = response.invoicePdf;
              // let pdfWindow = window.open("")
              // pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe>")
              console.log('Respuesta -> ', response.megaprintBody);
              this._printService.receiptPrint(response.megaprintBody, this.companyLogoUrl, 1);

              if(this.orderActive){

                // console.log('Actualizar Orden');
                this.productsByCheck.forEach(async product => {
                  await this.deleteLine(product.itemCode);
                });

                let json = {
                  "store": {
                    "storeCode": this.storeCode
                  },
                  "user": {
                    "userCode": this.userCode
                  },
                  "table": {
                    "tableCode": this.mesaOrden
                  },
                  "detail": this.invoiceLine,
                  "orderCode": this.orderID,
                  "status": closeOrder //Cerrada
                };
          
                await this._restaurantService.updateOrder(json).then(
                  async (response) => {
                    if (response.result) {            
                      this._utilsService.showNotification(1, response.message);

                      this.productsByCheck = [];
                      this.showInvoiceInfo = false;
                      // if(closeOrder == 0){
                      //   this.viewBeginning();
                      //   this.cleanModel();
                      //   this.closeOrder = true;
                      // }

                      if(this.closeOrderComplete){ //Limpiar Ticket
                        await this.viewBeginning();
                        this.cleanModel();
                        this.closeOrder = true;
                        console.log('Limpia pantalla orden finalizada recibo carta');
                      }
                      else{
                        await this.viewBeginning();
                        console.log('Limpia pantalla orden abierta');
                      }

                      // 
                    } else {
                      this._utilsService.showNotification(3, response.errorMessage);
                    }
                  },
                  error => {
                    this._utilsService.showNotification(2, error);
                    console.log(error);
                  }
                ).finally(() => {
                  this.loading = false;   
                });
              }              
              
            }
            this._utilsService.showNotification(1, response.message);
          }
          else
          {
            this._utilsService.showNotification(3, response.errorMessage);
          }
        },
        error => {
          this._utilsService.showNotification(2, error);
          console.log(error);
        }
      ).finally(() => {
        this.loading = false;
        this.isDisabled = false;
        this.disabled = false;
      });

    }

    this.isDisabled = false;
    this.disabled = false;
    this.insertNewClient = false;
    
    if(this.companyCode == 22){
      this.isNailCenter = true;
      this.getAll(this.storeCode);

      var amountsByPayType = JSON.parse(localStorage.getItem('salesAmounts'));
      this.PaymentLine.forEach(element => {
        amountsByPayType.paymentType.forEach(payType => {
          console.log(amountsByPayType.paymentType)
          if(payType.id == element.typePayment){
            payType.amount += element.MontoPayment
          }
        });
      });

      localStorage.setItem('salesAmounts', JSON.stringify(amountsByPayType))
    }
    
  }

  // GET ALL INVENTORY
  getAll(storeCode) {
    this.loading = true;
    // console.log(storeCode, "este es el store code para nail center")
    return this._inventoryService.getAllByStore(storeCode).then(
      response => {
        if (response.result) {
          //this.inventoryList = response.records;
          this.temp = response.records;
          console.log(this.inventoryList);
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  // GET ONE INVENTORY
  viewFunction($event) {
    $event.preventDefault();
    let series;
    this.activeRow.inventorySerialFlag == 1 ? series = 'SI' : series = 'NO';

    swal.fire({
      title: "Item:",
      imageUrl: `https://storage.googleapis.com/nail-center/Imagenes/${this.activeRow.inventoryBusinessCode}.jfif`,
      imageHeight: 300,
      html:
        '<div class="text-left">' +
        "<b>Código: </b>" +
        this.activeRow.inventoryBusinessCode +
        "<br>" +
        "<b>Nombre: </b>" +
        this.activeRow.inventoryName +
        "<br>" +
        "<b>Series: </b>" +
        series +
        "<hr>" +
        "<b>Precio Venta: </b>" +
        this.activeRow.inventoryPrice +
        "<br>" +
        "<b>Precio Minimo de Venta: </b>" +
        this.activeRow.inventoryMinPrice +
        "<br>" +
        "<b>Precio con Descuento: </b>" +
        this.activeRow.inventoryPriceDiscount +
        "<br>" +
        "<b>Precio de Promoción: </b>" +
        this.activeRow.inventorySalePrice +
        "<hr>" +
        "<b>Stock: </b>" +
        this.activeRow.inventoryQuantity +
        "<br>" +
        "<b>Stock Mínimo: </b>" +
        this.activeRow.inventoryMin +
        "<br>" +
        "<b>Stock Máximo: </b>" +
        this.activeRow.inventoryMax +
        "<hr>" +
        "<b>Cód. de Orden: </b>" +
        this.activeRow.inventoryPurchaseDetail +
        "<br>" +
        "<b>Descripción: </b>" +
        this.activeRow.inventoryDescription +
        "<br></div>",
      customClass: {
        confirmButton: "btn btn-success",
      },
      width: 650,
      confirmButtonText: "Aceptar",
      buttonsStyling: false,
    });
  }
  
  onActivate(event) {
    this.activeRow = event.row;
  }

  async printLetter() {
    //const pdfWindow = window.open("", 'Factura', '_blank');
    const pdfWindow = window.open();
    let NCE = "";
    if(this.tipoCliente == 0){
      NCE = "NIT: "
    }
    else if(this.tipoCliente == 1){
      NCE = "CUI: "
    }
    else if(this.tipoCliente == 2){
      NCE = "EXT: "
    }

    const css = `<style>   
        td { font-size: 12px; padding: 2px;}     
        .brDescr {border-right: 1px solid  #2CA8FF; border-top: 1px solid  #2CA8FF; border-bottom: 1px solid  #2CA8FF;}
        .brCompl {border-right: 1px solid  #2CA8FF; border-top: 1px solid  #2CA8FF;}
      </style>`;
    var html = `
    <head><title>Factura Clever "${this.company.companyName + ' - ' + this.storeName}"</title></head>
    <body style="width: 21cm; height: 27cm; margin: auto; font-family: sans-serif, system-ui, monospace;"> 
      <div style="border: 2px solid #2CA8FF; border-radius: 10px; width: auto;">
        <table style="width: 100%;">
              <tr>
                  <td rowspan="5" style="width: 19%;">
                      <img style="width: 110px; margin:10px auto; display:block;" src="${this.companyLogoUrl}">
                  </td>
                  <th style="width: 62%; font-size: 19px; text-align: cent  er;">                      
                      ${this.fel.transmitter.transmitterComercialName}
                  </th>
                  <td style="width: 19%; font-size: 10px;">
                      Vendedor: ${this.userName}
                  </td>
              </tr>
              <tr>
                  <td style="text-align: center;">
                    ${this.fel.transmitter.transmitterName}
                  </td>
                  <td style="font-size: 10px;">Factura Electronica Fel</td>
              </tr>
              <tr>
                  <td style="text-align: center;">
                      NIT: ${this.fel.transmitter.transmitterTaxDocument}
                  </td>
                  <td>Serie: ${this.dte.serie}</td>
              </tr>
              <tr>
                  <td style="text-align: center;">
                      Tel: ${this.store.storePhone}<br>
                      ${this.fel.transmitter.transmitterAddress}. ${this.fel.transmitter.transmitterMunicipality}, ${this.fel.transmitter.transmitterDepartment}
                  </td>
                  <td>No. DTE: ${this.dte.noFactura}</td>
              </tr>
              <tr>
                  <th style="text-align: center;">FACTURA</th>
                  <td>Fecha: ${this.pipeFecha.transform(this.fel.invoice.invoiceDate, 'dd-MM-yyy')}</td>
              </tr>
        </table>
      </div>
      <br>
      <div style="border: 2px solid #2CA8FF; border-radius: 10px 10px 0px 0px; width: auto; min-height: 750px" >
        <table cellspacing="0" cellpadding="0" style="width: 100%;">
            <tr style="max-height: 15px;">
              <td colspan="4"> Nombre: ${this.fel.receiver.receiverName}</td>
              <td colspan="3"> Nit: ${this.fel.receiver.receiverTaxDocument}</td>
            </tr>
            <tr style="max-height: 15px;">
              <td colspan="7"> Dirección: ${this.fel.receiver.receiverAddress}</td>
            </tr>
            <tr style="font-size: 11px; text-align: center;">
              <th class="brDescr">CANTIDAD</th>
              <th class="brDescr">TIPO</th>
              <th class="brDescr" style="width: 320px;">DESCRIPCIÓN</th>
              <th class="brDescr">PRECIO UNI.</th>
              <th class="brDescr">IMPUESTO</th>
              <th class="brDescr">DESCUENTO</th>
              <th class="brDescr" style="width: 120px;">TOTAL</th>
            </tr>`;
    
    for (const e of this.felDetail) {
      html += `<tr">
        <td style="text-align: center; "> ${this._pipeNumero.transform(e.quantity, '1.2-2')}</td>
        <td style="text-align: center;"> ${e.isService}</td>
        <td>${e.description}</td>
        <td style="text-align: right;"> ${this._pipeNumero.transform(e.unitPrice, '1.2-2')}</td>
        <td style="text-align: right;"> ${this._pipeNumero.transform(e.taxAmount, '1.2-2')}</td>
        <td style="text-align: right;"> ${this._pipeNumero.transform(e.discount, '1.2-2')}</td>
        <td style="text-align: right;"> ${this._pipeNumero.transform(e.total, '1.2-2')}</td>
        </tr>`
    };

    html += `          
        </table>
      </div>
      <div style="border: 2px solid #2CA8FF; border-radius: 0px 0px 10px 10px; width: auto;">
        <table cellspacing="0" style="width: 100%;">
              <tr>
                <td colspan="7" style="text-align: center; font-size: 10px;">${this.regimenMessage}</td>
              </tr>
              <tr style="height: 30px;">
                <td class="brCompl" style="max-width: 22px; padding-left: 5px;">Total en Letras:</td>
                  <td class="brCompl" style="font-size: 10px max-width: 65px; text-align: left;">${this.pipeLetra.transform(this.fel.invoice.invoiceTotal)}</td>
                  <th style="font-size: 14px; max-width: 65px; text-align: right; border-top: 1px solid  #2CA8FF;">
                    TOTAL: Q ${this._pipeNumero.transform(this.fel.invoice.invoiceTotal, '1.2-2')}
                  </th>
              </tr>
          </table>
      </div> 
      <br>
      <table style="border: 2px solid #2CA8FF; border-radius: 10px; width: 100%;" padding: 10px;" >
          <tr><td>
            No. de Autorización: ${this.dte.autorizacion}<br>
            Fecha de Certificación: ${this.dte.fechaCertificacion}  
          </td></tr>
          <tr><td style="text-align: center">Certificador: ${this.dte.certificador}. Nit: ${this.dte.nitCertificador}</td></tr>
      </table>
    </body>`;

    await pdfWindow.document.write(css + html);  //setTimeout( () => {pdfWindow.window.open()}, 1100)
    this.continue();
  }

  // Limpiar Campos
  async cleanModel() {    
    
    this.addAmount = true;
    this.isDisabled = false;
    this.disabled = false;
    this.insertNewClient = false;
    this.recurrentClient = false;
    this.client = {} as Client;
    this.invoiceHeader = {} as InvoiceHeader;
    this.invoiceDetail = {} as InvoiceDetail;
    this.invoiceLine = [];
    this.moneda = "Q";
    this.petroleo = null;
    this.taxOilAmount = 0;
    this.taxOilCode = null;
    this.invoiceHeader.invoiceIDP = 0;
    this.invoiceHeader.invoiceTax = 0;
    this.invoiceHeader.invoiceTotal = 0;
    this.invoiceHeader.invoiceCoin = 0;
    this.invoiceHeader.invoiceCurrency = 'GTQ';
    this.invoiceHeader.origenCompra = 1;
    this.invoiceDetail.invoiceDetailType = 'B';    
    this.invoiceDetail.invoiceDetailQuantity = 1;
    this.invoiceHeader.invoiceInternSerial = 'A';
    this.invoiceHeader.paymentType = 0;
    this.tipoPago = 0;
    this.invoiceHeader.invoiceDate = this.nowDay;
    this.client.clientType = 0;
    this.OrdenCompra = "0";
    this.phoneWhastapp = "";

    this.jumpSerial = false;
    this.idp = 0;
    this.subIdp = 0;
    this.subsidio = 0;
    this.subsidioTemp = 0;
    //this.taxToPay = 0;
    this.priceType = 1;
    this.PaymentLine = [];
    this.MontoTotalPayment = 0.00;
    this.amountToPay = 0.00;
    this.MontoPayment = 0;
    this.changeMoney = 0;
    this.Money = 0;
    this.Propina = 0;

    this.orderActive = false;
    this.isChecked = false;
    this.isDisabledInvoice = true;
    this.viewProp = false;

    if (this.isParamsUrl) {
      this.router.navigate([], { relativeTo: this.activatedRoute });
    }

    //await this.getAll(this.storeCode);
  }

  ///////////////////////PANTALLAS///////////////////////
  async viewBeginning() {
    this.isBeginning = true;
    this.isBilling = true;
    this.isPrintT = false;
    this.isPrintTR = false;
    this.isPrintOrder = false;
    this.isPrintL = false;
    // console.log('Tipo ', this.client.clientType);
    this.client.clientType = 0;
    this.tipoCliente = 0;
    this.ordersLocked = true;
    this.PaymentStatus = false;
    this.all = false;
    this.cleanModel();
    await this.getTablesList(this.storeCode);
    console.log('viewBeginning');
  }

  viewBilling() {
    this.isBeginning = false;
    this.isBilling = true;
    this.isPrintT = false;
    this.isPrintTR = false;
    this.isPrintOrder = false;
    this.isPrintL = false;
  }

  viewPrint(typeDoc) {
    //this.isBeginning = false;
    //this.isBilling = false;
    
    // this.company.companyInvoicePrint === 1 ? this.isPrintT = true : this.isPrintL = true;
    //this.company.companyInvoicePrint === 1 ? this.isPrintT = true : this.printLetter();

    console.log("Ticket Formato",typeDoc);
    if(this.company.companyInvoicePrint === 1){
      console.log("IMPRIME COMO TICKET");
      this.isPrintT = true;

      if(typeDoc == 2){ //Ticket Recibo
        this.isPrintTR = true;
      }
      else{ //Carta Recibo
        this.isPrintTR = false;
      }

      console.log(this.isPrintT, this.isPrintTR);

    }
    else{

      console.log("IMPRIME EN CARTA");
      this.printLetter();

    }
  }

  async printOrder(){
    console.log('Orden Imprimir:',this.invoiceLine);

    if(this.invoiceLine.length > 0){

      await this.saveOrder();

      this._restaurantService.getOrder(this.storeCode,this.mesaOrden, 1).then(
        async response => {
          if (response.result) {
            //SI LA MESA TIENE ORDEN ABIERTA
            if(response.records.length >= 1){
              this.orderID = response.records[0].restaurantOrdersCode;

              this.isPrintOrder = true;
              this.printTestOrder();
            }            
          } else {
            console.log(response.message);
          }
        },
        error => {
          console.log(error);
        }
      ).finally(() => {
        this.loading = false;
      });

    }
    else{
      this._utilsService.showNotification(5, "No hay productos a imprimir en la orden");
    }    
  }

  viewCF() {
    this.isBeginning = true;
    this.isBilling = true;
    this.isPrintT = false;
    this.isPrintTR = false;
    this.isPrintOrder = false;
    this.isPrintL = false;
    this.disabled = true;
    this.isDisabled = true;
    console.log('TP CF-> ', this.tipoCliente);
    this.client.clientType = this.tipoCliente;
  }

  ValidarCF() {
    /*J11 - Validar CF*/
    console.log(this.invoiceHeader.invoiceTotal);
    console.log(this.client.clientTaxDocument);

    if(this.invoiceHeader.invoiceTotal >= 2500){
      if(this.client.clientTaxDocument == "CF"){
        this._utilsService.showNotification(5, "No puede facturar como CF, el monto es mayor a 2500");
        // this.addPaymentMethodEnabled = false;
        this.viewCF();
      }
      else{
        this.disabled = false;
        // this.addPaymentMethodEnabled = true;
      }
    }
  }

  async continue() {

    if(this.closeOrderComplete){ //Limpiar Ticket
      await this.viewBeginning();
      this.cleanModel();
      this.closeOrder = true;
      console.log('Limpia pantalla orden finalizada continue');
    }
    else{
      await this.viewBeginning();
      console.log('Limpia pantalla orden abierta');
    }

    // this.viewBeginning();
    // this.cleanModel();
  }

  // PRINT
  printTest() {
    printJS({
      printable: "printSection",
      type: "html",
      style: "#printSection{width: 224px; text-align: center};",
    });
  }

  printTestOrder() {
    printJS({
      printable: "printSectionOrder",
      type: "html",
      style: "#printSectionOrder{width: 224px; text-align: center};",
    });
  }

  continueOrder() {
    this.isPrintOrder = false;
  }
}
